var $a0b4f895e1596b3b$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return n(r, t, e, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return n(r, t, e, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return n(r, t, e, u, a, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return n(r, t, e, u, a, i, o);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, u) {
        return 4 === n.a ? n.f(r, t, e, u) : n(r)(t)(e)(u);
    }
    function A5(n, r, t, e, u, a) {
        return 5 === n.a ? n.f(r, t, e, u, a) : n(r)(t)(e)(u)(a);
    }
    function A6(n, r, t, e, u, a, i) {
        return 6 === n.a ? n.f(r, t, e, u, a, i) : n(r)(t)(e)(u)(a)(i);
    }
    function A7(n, r, t, e, u, a, i, o) {
        return 7 === n.a ? n.f(r, t, e, u, a, i, o) : n(r)(t)(e)(u)(a)(i)(o);
    }
    var t = F3(function(n, r, t) {
        for(var e = Array(n), u = 0; n > u; u++)e[u] = t(r + u);
        return e;
    }), e = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, c(t, r);
    });
    function u(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function a(n, r) {
        for(var t, e = [], u = i(n, r, 0, e); u && (t = e.pop()); u = i(t.a, t.b, 0, e));
        return u;
    }
    function i(n, r, t, e) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && u(5), !1;
        if (t > 100) return e.push(c(n, r)), !0;
        for(var a in 0 > n.$ && (n = Or(n), r = Or(r)), n)if (!i(n[a], r[a], t + 1, e)) return !1;
        return !0;
    }
    function o(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = o(n.a, r.a)) || (t = o(n.b, r.b)) ? t : o(n.c, r.c);
        for(; n.b && r.b && !(t = o(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var f = F2(function(n, r) {
        var t = o(n, r);
        return 0 > t ? Qr : t ? Mr : Tr;
    });
    function c(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function s(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function l(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    function d(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = v(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = v(n.a, r);
        return t;
    }
    var b = {
        $: 0
    };
    function v(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var h = F2(v);
    function g(n) {
        for(var r = b, t = n.length; t--;)r = v(n[t], r);
        return r;
    }
    function p(n) {
        for(var r = []; n.b; n = n.b)r.push(n.a);
        return r;
    }
    var $ = F3(function(n, r, t) {
        for(var e = []; r.b && t.b; r = r.b, t = t.b)e.push(A2(n, r.a, t.a));
        return g(e);
    }), m = F2(function(n, r) {
        return g(p(r).sort(function(r, t) {
            return o(n(r), n(t));
        }));
    }), k = F2(function(n, r) {
        return n + r;
    }), w = Math.ceil, y = Math.floor, x = Math.round, A = Math.log, z = isNaN, C = F2(function(n, r) {
        return n + r;
    }), q = F2(function(n, r) {
        for(var t = [], e = r.length, u = 0; e > u;){
            var a = r[u], i = r.charCodeAt(u);
            u++, 55296 > i || i > 56319 || (a += r[u], u++), n(a) && t.push(a);
        }
        return t.join("");
    }), j = F3(function(n, r, t) {
        for(var e = t.length; e--;){
            var u = t[e], a = t.charCodeAt(e);
            56320 > a || a > 57343 || (u = t[--e] + u), r = A2(n, u, r);
        }
        return r;
    }), E = F2(function(n, r) {
        return r.split(n);
    }), N = F2(function(n, r) {
        return r.join(n);
    }), S = F3(function(n, r, t) {
        return t.slice(n, r);
    }), P = F2(function(n, r) {
        for(var t = r.length; t--;){
            var e = r[t], u = r.charCodeAt(t);
            if (56320 > u || u > 57343 || (e = r[--t] + e), !n(e)) return !1;
        }
        return !0;
    }), F = F2(function(n, r) {
        return r.indexOf(n) > -1;
    }), D = F2(function(n, r) {
        return 0 === r.indexOf(n);
    }), L = F2(function(n, r) {
        var t = n.length;
        if (1 > t) return b;
        for(var e = 0, u = []; (e = r.indexOf(n, e)) > -1;)u.push(e), e += t;
        return g(u);
    });
    function O(n) {
        return n + "";
    }
    function T(n) {
        return {
            $: 2,
            b: n
        };
    }
    var M = T(function(n) {
        return "number" != typeof n ? rn("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? Hr(n) : !isFinite(n) || n % 1 ? rn("an INT", n) : Hr(n);
    }), Q = (T(function(n) {
        return "boolean" == typeof n ? Hr(n) : rn("a BOOL", n);
    }), T(function(n) {
        return "number" == typeof n ? Hr(n) : rn("a FLOAT", n);
    })), I = T(function(n) {
        return Hr(n);
    }), V = T(function(n) {
        return "string" == typeof n ? Hr(n) : n instanceof String ? Hr(n + "") : rn("a STRING", n);
    }), _ = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    function B(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var H = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), R = F2(function(n, r) {
        return B(n, [
            r
        ]);
    }), U = F3(function(n, r, t) {
        return B(n, [
            r,
            t
        ]);
    }), W = F4(function(n, r, t, e) {
        return B(n, [
            r,
            t,
            e
        ]);
    }), K = F5(function(n, r, t, e, u) {
        return B(n, [
            r,
            t,
            e,
            u
        ]);
    }), G = F7(function(n, r, t, e, u, a, i) {
        return B(n, [
            r,
            t,
            e,
            u,
            a,
            i
        ]);
    }), Y = F2(function(n, r) {
        return J(n, r);
    });
    function J(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? Hr(n.c) : rn("null", r);
            case 3:
                return Z(r) ? X(n.b, r, g) : rn("a LIST", r);
            case 4:
                return Z(r) ? X(n.b, r, nn) : rn("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return rn("an OBJECT with a field named `" + t + "`", r);
                var e = J(n.b, r[t]);
                return jt(e) ? e : Ir(A2(_r, t, e.a));
            case 7:
                var u = n.e;
                return Z(r) ? r.length > u ? (e = J(n.b, r[u]), jt(e) ? e : Ir(A2(Br, u, e.a))) : rn("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : rn("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || Z(r)) return rn("an OBJECT", r);
                var a = b;
                for(var i in r)if (r.hasOwnProperty(i)) {
                    if (e = J(n.b, r[i]), !jt(e)) return Ir(A2(_r, i, e.a));
                    a = v(c(i, e.a), a);
                }
                return Hr(ot(a));
            case 9:
                for(var o = n.f, f = n.g, s = 0; f.length > s; s++){
                    if (e = J(f[s], r), !jt(e)) return e;
                    o = o(e.a);
                }
                return Hr(o);
            case 10:
                return e = J(n.b, r), jt(e) ? J(n.h(e.a), r) : e;
            case 11:
                for(var l = b, d = n.g; d.b; d = d.b){
                    if (e = J(d.a, r), jt(e)) return e;
                    l = v(e.a, l);
                }
                return Ir(Rr(ot(l)));
            case 1:
                return Ir(A2(Vr, n.a, r));
            case 0:
                return Hr(n.a);
        }
    }
    function X(n, r, t) {
        for(var e = r.length, u = Array(e), a = 0; e > a; a++){
            var i = J(n, r[a]);
            if (!jt(i)) return Ir(A2(Br, a, i.a));
            u[a] = i.a;
        }
        return Hr(t(u));
    }
    function Z(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function nn(n) {
        return A2(qt, n.length, function(r) {
            return n[r];
        });
    }
    function rn(n, r) {
        return Ir(A2(Vr, "Expecting " + n, r));
    }
    function tn(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return tn(n.b, r.b);
            case 6:
                return n.d === r.d && tn(n.b, r.b);
            case 7:
                return n.e === r.e && tn(n.b, r.b);
            case 9:
                return n.f === r.f && en(n.g, r.g);
            case 10:
                return n.h === r.h && tn(n.b, r.b);
            case 11:
                return en(n.g, r.g);
        }
    }
    function en(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!tn(n[e], r[e])) return !1;
        return !0;
    }
    function un(n) {
        return n;
    }
    function an(n) {
        return {
            $: 0,
            a: n
        };
    }
    function on(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var fn = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), cn = F2(function(n, r) {
        return {
            $: 4,
            b: n,
            d: r
        };
    }), sn = 0;
    function ln(n) {
        var r = {
            $: 0,
            e: sn++,
            f: n,
            g: null,
            h: []
        };
        return pn(r), r;
    }
    function dn(n) {
        return on(function(r) {
            r(an(ln(n)));
        });
    }
    function bn(n, r) {
        n.h.push(r), pn(n);
    }
    var vn = F2(function(n, r) {
        return on(function(t) {
            bn(n, r), t(an(0));
        });
    }), hn = !1, gn = [];
    function pn(n) {
        if (gn.push(n), !hn) {
            for(hn = !0; n = gn.shift();)$n(n);
            hn = !1;
        }
    }
    function $n(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, pn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var mn = {};
    function kn(n, r, t, e, u) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: u
        };
    }
    function wn(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, u = n.d, a = n.e, i = n.f;
        function o(n) {
            return A2(fn, o, {
                $: 5,
                b: function(r) {
                    var o = r.a;
                    return 0 === r.$ ? A3(u, t, o, n) : a && i ? A4(e, t, o.i, o.j, n) : A3(e, t, a ? o.i : o.j, n);
                }
            });
        }
        return t.h = ln(A2(fn, o, n.b));
    }
    var yn = F2(function(n, r) {
        return on(function(t) {
            n.g(r), t(an(0));
        });
    }), xn = F2(function(n, r) {
        return A2(vn, n.h, {
            $: 0,
            a: r
        });
    });
    function An(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function zn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var Cn = [], qn = !1;
    function jn(n, r, t) {
        if (Cn.push({
            p: n,
            q: r,
            r: t
        }), !qn) {
            qn = !0;
            for(var e; e = Cn.shift();)En(e.p, e.q, e.r);
            qn = !1;
        }
    }
    function En(n, r, t) {
        var e = {};
        for(var u in Nn(!0, r, e, null), Nn(!1, t, e, null), n)bn(n[u], {
            $: "fx",
            a: e[u] || {
                i: b,
                j: b
            }
        });
    }
    function Nn(n, r, t, e) {
        switch(r.$){
            case 1:
                var u = r.k, a = function(n, r, t, e) {
                    function u(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? mn[r].e : mn[r].f, u, e);
                }(n, u, e, r.l);
                return void (t[u] = function(n, r, t) {
                    return t = t || {
                        i: b,
                        j: b
                    }, n ? t.i = v(r, t.i) : t.j = v(r, t.j), t;
                }(n, a, t[u]));
            case 2:
                for(var i = r.m; i.b; i = i.b)Nn(n, i.a, t, e);
                return;
            case 3:
                return void Nn(n, r.o, t, {
                    s: r.n,
                    t: e
                });
        }
    }
    function Sn(n) {
        mn[n] && u(3);
    }
    function Pn(n, r) {
        return Sn(n), mn[n] = {
            e: Fn,
            u: r,
            a: Dn
        }, An(n);
    }
    var Fn = F2(function(n, r) {
        return r;
    });
    function Dn(n) {
        var r = [], t = mn[n].u, e = on(function(n) {
            var r = setTimeout(function() {
                n(an(0));
            }, 0);
            return function() {
                clearTimeout(r);
            };
        });
        return mn[n].b = e, mn[n].c = F3(function(n, u) {
            for(; u.b; u = u.b)for(var a = r, i = t(u.a), o = 0; a.length > o; o++)a[o](i);
            return e;
        }), {
            subscribe: function(n) {
                r.push(n);
            },
            unsubscribe: function(n) {
                var t = (r = r.slice()).indexOf(n);
                0 > t || r.splice(t, 1);
            }
        };
    }
    function Ln(n, r) {
        return Sn(n), mn[n] = {
            f: Tn,
            u: r,
            a: Mn
        }, An(n);
    }
    var On, Tn = F2(function(n, r) {
        return function(t) {
            return n(r(t));
        };
    });
    function Mn(n, r) {
        var t = b, e = mn[n].u, a = an(null);
        return mn[n].b = a, mn[n].c = F3(function(n, r) {
            return t = r, a;
        }), {
            send: function(n) {
                var a = A2(Y, e, n);
                jt(a) || u(4);
                for(var i = a.a, o = t; o.b; o = o.b)r(o.a(i));
            }
        };
    }
    var Qn = "undefined" != typeof document ? document : {};
    function In(n, r) {
        n.appendChild(r);
    }
    function Vn(n) {
        return {
            $: 0,
            a: n
        };
    }
    var _n = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 1,
                c: r,
                d: Jn(t),
                e: u,
                f: n,
                b: a
            };
        });
    }), Bn = _n(void 0);
    F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 2,
                c: r,
                d: Jn(t),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0);
    var Hn, Rn = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), Un = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), Wn = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), Kn = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    }), Gn = /^script$/i, Yn = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
    function Jn(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, u = t.n, a = t.o;
            if ("a2" !== e) {
                var i = r[e] || (r[e] = {});
                "a3" === e && "class" === u ? Xn(i, u, a) : i[u] = a;
            } else "className" === u ? Xn(r, u, a) : r[u] = a;
        }
        return r;
    }
    function Xn(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function Zn(n, r) {
        var t = n.$;
        if (5 === t) return Zn(n.k || (n.k = n.m()), r);
        if (0 === t) return Qn.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, u = n.j; 4 === e.$;)"object" != typeof u ? u = [
                u,
                e.j
            ] : u.push(e.j), e = e.k;
            var a = {
                j: u,
                p: r
            };
            return (i = Zn(e, a)).elm_event_node_ref = a, i;
        }
        if (3 === t) return nr(i = n.h(n.g), r, n.d), i;
        var i = n.f ? Qn.createElementNS(n.f, n.c) : Qn.createElement(n.c);
        On && "a" == n.c && i.addEventListener("click", On(i)), nr(i, r, n.d);
        for(var o = n.e, f = 0; o.length > f; f++)In(i, Zn(1 === t ? o[f] : o[f].b, r));
        return i;
    }
    function nr(n, r, t) {
        for(var e in t){
            var u = t[e];
            "a1" === e ? rr(n, u) : "a0" === e ? ur(n, r, u) : "a3" === e ? tr(n, u) : "a4" === e ? er(n, u) : ("value" !== e && "checked" !== e || n[e] !== u) && (n[e] = u);
        }
    }
    function rr(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function tr(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function er(n, r) {
        for(var t in r){
            var e = r[t], u = e.f, a = e.o;
            void 0 !== a ? n.setAttributeNS(u, t, a) : n.removeAttributeNS(u, t);
        }
    }
    function ur(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var u in t){
            var a = t[u], i = e[u];
            if (a) {
                if (i) {
                    if (i.q.$ === a.$) {
                        i.q = a;
                        continue;
                    }
                    n.removeEventListener(u, i);
                }
                i = ar(r, a), n.addEventListener(u, i, Hn && {
                    passive: 2 > Pt(a)
                }), e[u] = i;
            } else n.removeEventListener(u, i), e[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                Hn = !0;
            }
        }));
    } catch (n) {}
    function ar(n, r) {
        function t(r) {
            var e = t.q, u = J(e.a, r);
            if (jt(u)) {
                for(var a, i = Pt(e), o = u.a, f = i ? 3 > i ? o.a : o.x : o, c = 1 == i ? o.b : 3 == i && o.az, s = (c && r.stopPropagation(), (2 == i ? o.b : 3 == i && o.aw) && r.preventDefault(), n); a = s.j;){
                    if ("function" == typeof a) f = a(f);
                    else for(var l = a.length; l--;)f = a[l](f);
                    s = s.p;
                }
                s(f, c);
            }
        }
        return t.q = r, t;
    }
    function ir(n, r) {
        return n.$ == r.$ && tn(n.a, r.a);
    }
    function or(n, r, t, e) {
        var u = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function fr(n, r, t, e) {
        if (n !== r) {
            var u = n.$, a = r.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void or(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), u = 0; t > u; u++)e[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), a = 1;
            }
            switch(a){
                case 5:
                    for(var i = n.l, o = r.l, f = i.length, c = f === o.length; c && f--;)c = i[f] === o[f];
                    if (c) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return fr(n.k, r.k, s, 0), void (s.length > 0 && or(t, 1, e, s));
                case 4:
                    for(var l = n.j, d = r.j, b = !1, v = n.k; 4 === v.$;)b = !0, "object" != typeof l ? l = [
                        l,
                        v.j
                    ] : l.push(v.j), v = v.k;
                    for(var h = r.k; 4 === h.$;)b = !0, "object" != typeof d ? d = [
                        d,
                        h.j
                    ] : d.push(h.j), h = h.k;
                    return b && l.length !== d.length ? void or(t, 0, e, r) : ((b ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(l, d) : l === d) || or(t, 2, e, d), void fr(v, h, t, e + 1));
                case 0:
                    return void (n.a !== r.a && or(t, 3, e, r.a));
                case 1:
                    return void cr(n, r, t, e, lr);
                case 2:
                    return void cr(n, r, t, e, dr);
                case 3:
                    if (n.h !== r.h) return void or(t, 0, e, r);
                    var g = sr(n.d, r.d);
                    g && or(t, 4, e, g);
                    var p = r.i(n.g, r.g);
                    return void (p && or(t, 5, e, p));
            }
        }
    }
    function cr(n, r, t, e, u) {
        if (n.c === r.c && n.f === r.f) {
            var a = sr(n.d, r.d);
            a && or(t, 4, e, a), u(n, r, t, e);
        } else or(t, 0, e, r);
    }
    function sr(n, r, t) {
        var e;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var a = n[u], i = r[u];
                a === i && "value" !== u && "checked" !== u || "a0" === t && ir(a, i) || ((e = e || {})[u] = i);
            } else (e = e || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var o = sr(n[u], r[u] || {}, u);
            o && ((e = e || {})[u] = o);
        }
        for(var f in r)f in n || ((e = e || {})[f] = r[f]);
        return e;
    }
    function lr(n, r, t, e) {
        var u = n.e, a = r.e, i = u.length, o = a.length;
        i > o ? or(t, 6, e, {
            v: o,
            i: i - o
        }) : o > i && or(t, 7, e, {
            v: i,
            e: a
        });
        for(var f = o > i ? i : o, c = 0; f > c; c++){
            var s = u[c];
            fr(s, a[c], t, ++e), e += s.b || 0;
        }
    }
    function dr(n, r, t, e) {
        for(var u = [], a = {}, i = [], o = n.e, f = r.e, c = o.length, s = f.length, l = 0, d = 0, b = e; c > l && s > d;){
            var v = (C = o[l]).a, h = (q = f[d]).a, g = C.b, p = q.b, $ = void 0, m = void 0;
            if (v !== h) {
                var k = o[l + 1], w = f[d + 1];
                if (k) {
                    var y = k.a, x = k.b;
                    m = h === y;
                }
                if (w) {
                    var A = w.a, z = w.b;
                    $ = v === A;
                }
                if ($ && m) fr(g, z, u, ++b), vr(a, u, v, p, d, i), b += g.b || 0, hr(a, u, v, x, ++b), b += x.b || 0, l += 2, d += 2;
                else if ($) b++, vr(a, u, h, p, d, i), fr(g, z, u, b), b += g.b || 0, l += 1, d += 2;
                else if (m) hr(a, u, v, g, ++b), b += g.b || 0, fr(x, p, u, ++b), b += x.b || 0, l += 2, d += 1;
                else {
                    if (!k || y !== A) break;
                    hr(a, u, v, g, ++b), vr(a, u, h, p, d, i), b += g.b || 0, fr(x, z, u, ++b), b += x.b || 0, l += 2, d += 2;
                }
            } else fr(g, p, u, ++b), b += g.b || 0, l++, d++;
        }
        for(; c > l;){
            var C;
            b++, hr(a, u, (C = o[l]).a, g = C.b, b), b += g.b || 0, l++;
        }
        for(; s > d;){
            var q, j = j || [];
            vr(a, u, (q = f[d]).a, q.b, void 0, j), d++;
        }
        (u.length > 0 || i.length > 0 || j) && or(t, 8, e, {
            w: u,
            x: i,
            y: j
        });
    }
    var br = "_elmW6BL";
    function vr(n, r, t, e, u, a) {
        var i = n[t];
        if (!i) return a.push({
            r: u,
            A: i = {
                c: 0,
                z: e,
                r: u,
                s: void 0
            }
        }), void (n[t] = i);
        if (1 === i.c) {
            a.push({
                r: u,
                A: i
            }), i.c = 2;
            var o = [];
            return fr(i.z, e, o, i.r), i.r = u, void (i.s.s = {
                w: o,
                A: i
            });
        }
        vr(n, r, t + br, e, u, a);
    }
    function hr(n, r, t, e, u) {
        var a = n[t];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var i = [];
                return fr(e, a.z, i, u), void or(r, 9, u, {
                    w: i,
                    A: a
                });
            }
            hr(n, r, t + br, e, u);
        } else {
            var o = or(r, 9, u, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: u,
                s: o
            };
        }
    }
    function gr(n, r, t, e) {
        pr(n, r, t, 0, 0, r.b, e);
    }
    function pr(n, r, t, e, u, a, i) {
        for(var o = t[e], f = o.r; f === u;){
            var c = o.$;
            if (1 === c) gr(n, r.k, o.s, i);
            else if (8 === c) o.t = n, o.u = i, (s = o.s.w).length > 0 && pr(n, r, s, 0, u, a, i);
            else if (9 === c) {
                o.t = n, o.u = i;
                var s, l = o.s;
                l && (l.A.s = n, (s = l.w).length > 0 && pr(n, r, s, 0, u, a, i));
            } else o.t = n, o.u = i;
            if (!(o = t[++e]) || (f = o.r) > a) return e;
        }
        var d = r.$;
        if (4 === d) {
            for(var b = r.k; 4 === b.$;)b = b.k;
            return pr(n, b, t, e, u + 1, a, n.elm_event_node_ref);
        }
        for(var v = r.e, h = n.childNodes, g = 0; v.length > g; g++){
            u++;
            var p = 1 === d ? v[g] : v[g].b, $ = u + (p.b || 0);
            if (!(u > f || f > $ || (o = t[e = pr(h[g], p, t, e, u, $, i)]) && (f = o.r) <= a)) return e;
            u = $;
        }
        return e;
    }
    function $r(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], u = e.t, a = mr(u, e);
            u === n && (n = a);
        }
        return n;
    }
    function mr(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, u = Zn(r, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), e && u !== n && e.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return nr(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return $r(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var a = (t = r.s).e, i = n.childNodes[e = t.v]; a.length > e; e++)n.insertBefore(Zn(a[e], r.u), i);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var o = t.A;
                return void 0 !== o.r && n.parentNode.removeChild(n), o.s = $r(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = Qn.createDocumentFragment(), e = 0; n.length > e; e++){
                                var u = n[e].A;
                                In(t, 2 === u.c ? u.s : Zn(u.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = $r(n, t.w);
                    for(var u = t.x, a = 0; u.length > a; a++){
                        var i = u[a], o = i.A, f = 2 === o.c ? o.s : Zn(o.z, r.u);
                        n.insertBefore(f, n.childNodes[i.r]);
                    }
                    return e && In(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                u(10);
        }
    }
    function kr(n) {
        if (3 === n.nodeType) return Vn(n.textContent);
        if (1 !== n.nodeType) return Vn("");
        for(var r = b, t = n.attributes, e = t.length; e--;){
            var u = t[e];
            r = v(A2(Kn, u.name, u.value), r);
        }
        var a = n.tagName.toLowerCase(), i = b, o = n.childNodes;
        for(e = o.length; e--;)i = v(kr(o[e]), i);
        return A3(Bn, a, r, i);
    }
    var wr = F4(function(n, r, t, e) {
        return function(n, r, t, e, a, i) {
            var o = A2(Y, n, r ? r.flags : void 0);
            jt(o) || u(2);
            var f = {}, c = t(o.a), s = c.a, l = i(b, s), d = function(n, r) {
                var t;
                for(var e in mn){
                    var u = mn[e];
                    u.a && ((t = t || {})[e] = u.a(e, r)), n[e] = wn(u, r);
                }
                return t;
            }(f, b);
            function b(n, r) {
                var t = A2(e, n, s);
                l(s = t.a, r), jn(f, t.b, a(s));
            }
            return jn(f, c.b, a(s)), d ? {
                ports: d
            } : {};
        }(r, e, n.br, n.bC, n.bA, function(r, t) {
            var e = n.ax && n.ax(r), u = n.bE, a = Qn.title, i = Qn.body, o = kr(i);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (xr(e), r(n), 1);
                }
                return function(u, a) {
                    n = u, a ? (r(n), 2 === t && (t = 1)) : (0 === t && xr(e), t = 2);
                };
            }(t, function(n) {
                On = e;
                var t = u(n), f = Bn("body")(b)(t.be), c = function(n, r) {
                    var t = [];
                    return fr(n, r, t, 0), t;
                }(o, f);
                i = function(n, r, t, e) {
                    return 0 === t.length ? n : (gr(n, r, t, e), $r(n, t));
                }(i, o, c, r), o = f, On = 0, a !== t.bB && (Qn.title = a = t.bB);
            });
        });
    }), yr = "undefined" != typeof cancelAnimationFrame ? cancelAnimationFrame : function(n) {
        clearTimeout(n);
    }, xr = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    };
    function Ar() {
        return Gt(Qn.location.href).a || u(1);
    }
    var zr = F2(function(n, r) {
        return A2(le, Yt, on(function() {
            history.pushState({}, "", r), n();
        }));
    }), Cr = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, qr = "undefined" != typeof document ? document : Cr, jr = "undefined" != typeof window ? window : Cr, Er = F3(function(n, r, t) {
        return dn(on(function() {
            function e(n) {
                ln(t(n));
            }
            return n.addEventListener(r, e, Hn && {
                passive: !0
            }), function() {
                n.removeEventListener(r, e);
            };
        }));
    }), Nr = F2(function(n, r) {
        var t = J(n, r);
        return jt(t) ? Wr(t.a) : Kr;
    });
    var Sr = F2(function(n, r) {
        return function(n, r) {
            return on(function(t) {
                xr(function() {
                    var e = document.getElementById(n);
                    t(e ? an(r(e)) : {
                        $: 1,
                        a: Dt(n)
                    });
                });
            });
        }(r, function(r) {
            return r[n](), 0;
        });
    });
    var Pr = F2(function(n, r) {
        var t = "g";
        n.bt && (t += "m"), n.bf && (t += "i");
        try {
            return Wr(RegExp(r, t));
        } catch (n) {
            return Kr;
        }
    }), Fr = F4(function(n, r, t, e) {
        var u = 0;
        return e.replace(r, function(r) {
            if (u++ >= n) return r;
            for(var e = arguments.length - 3, a = Array(e); e > 0;){
                var i = arguments[e];
                a[--e] = i ? Wr(i) : Kr;
            }
            return t(A4(zi, r, arguments[arguments.length - 2], u, g(a)));
        });
    }), Dr = h, Lr = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, u = n, a = A3(n, t.b, t.c, A3(Lr, n, r, t.e));
            n = u, r = a, t = e;
        }
    }), Or = function(n) {
        return A3(Lr, F3(function(n, r, t) {
            return A2(Dr, c(n, r), t);
        }), b, n);
    }, Tr = 1, Mr = 2, Qr = 0, Ir = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Vr = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), _r = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Br = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Hr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Rr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ur = k, Wr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Kr = {
        $: 1
    }, Gr = P, Yr = O, Jr = F2(function(n, r) {
        return A2(N, n, p(r));
    }), Xr = F2(function(n, r) {
        return g(A2(E, n, r));
    }), Zr = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, u = n, a = A2(n, t.a, r);
            n = u, r = a, t = e;
        }
    }), nt = function(n) {
        return A3(Zr, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, rt = $, tt = F3(function(n, r, t) {
        for(;;){
            if (o(n, r) >= 1) return t;
            var e = n, u = r - 1, a = A2(Dr, r, t);
            n = e, r = u, t = a;
        }
    }), et = F2(function(n, r) {
        return A3(tt, n, r, b);
    }), ut = F2(function(n, r) {
        return A3(rt, n, A2(et, 0, nt(r) - 1), r);
    }), at = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, it = function(n) {
        var r = at(n);
        return 57 >= r && r >= 48;
    }, ot = function(n) {
        return A3(Zr, Dr, b, n);
    }, ft = function(n) {
        var r = n.charCodeAt(0);
        return isNaN(r) ? Kr : Wr(55296 > r || r > 56319 ? c(n[0], n.slice(1)) : c(n[0] + n[1], n.slice(2)));
    }, ct = 32, st = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), lt = [], dt = w, bt = F2(function(n, r) {
        return A(r) / A(n);
    }), vt = function(n) {
        return n;
    }, ht = dt(A2(bt, 2, ct)), gt = A4(st, 0, ht, lt, lt), pt = t, $t = y, mt = function(n) {
        return n.length;
    }, kt = F2(function(n, r) {
        return o(n, r) > 0 ? n : r;
    }), wt = e, yt = F2(function(n, r) {
        for(;;){
            var t = A2(wt, ct, n), e = t.b, u = A2(Dr, {
                $: 0,
                a: t.a
            }, r);
            if (!e.b) return ot(u);
            n = e, r = u;
        }
    }), xt = function(n) {
        return n.a;
    }, At = F2(function(n, r) {
        for(;;){
            var t = dt(r / ct);
            if (1 === t) return A2(wt, ct, n).a;
            n = A2(yt, n, b), r = t;
        }
    }), zt = F2(function(n, r) {
        if (r.b) {
            var t = r.b * ct, e = $t(A2(bt, ct, t - 1)), u = n ? ot(r.e) : r.e, a = A2(At, u, r.b);
            return A4(st, mt(r.d) + t, A2(kt, 5, e * ht), a, r.d);
        }
        return A4(st, mt(r.d), ht, lt, r.d);
    }), Ct = F5(function(n, r, t, e, u) {
        for(;;){
            if (0 > r) return A2(zt, !1, {
                e: e,
                b: t / ct | 0,
                d: u
            });
            var a = {
                $: 1,
                a: A3(pt, ct, r, n)
            };
            r -= ct, e = A2(Dr, a, e);
        }
    }), qt = F2(function(n, r) {
        if (n > 0) {
            var t = n % ct;
            return A5(Ct, r, n - t - ct, n, b, A3(pt, t, n - t, r));
        }
        return gt;
    }), jt = function(n) {
        return !n.$;
    }, Et = R, Nt = U, St = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Pt = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, Ft = function(n) {
        return n;
    }, Dt = Ft, Lt = F6(function(n, r, t, e, u, a) {
        return {
            aM: a,
            aN: r,
            aU: e,
            aX: t,
            a0: n,
            a1: u
        };
    }), Ot = F, Tt = function(n) {
        return n.length;
    }, Mt = S, Qt = F2(function(n, r) {
        return 1 > n ? r : A3(Mt, n, Tt(r), r);
    }), It = L, Vt = function(n) {
        return "" === n;
    }, _t = F2(function(n, r) {
        return 1 > n ? "" : A3(Mt, 0, n, r);
    }), Bt = function(n) {
        for(var r = 0, t = n.charCodeAt(0), e = 43 == t || 45 == t ? 1 : 0, u = e; n.length > u; ++u){
            var a = n.charCodeAt(u);
            if (48 > a || a > 57) return Kr;
            r = 10 * r + a - 48;
        }
        return u == e ? Kr : Wr(45 == t ? -r : r);
    }, Ht = F5(function(n, r, t, e, u) {
        if (Vt(u) || A2(Ot, "@", u)) return Kr;
        var a = A2(It, ":", u);
        if (a.b) {
            if (a.b.b) return Kr;
            var i = a.a, o = Bt(A2(Qt, i + 1, u));
            if (1 === o.$) return Kr;
            var f = o;
            return Wr(A6(Lt, n, A2(_t, i, u), f, r, t, e));
        }
        return Wr(A6(Lt, n, u, Kr, r, t, e));
    }), Rt = F4(function(n, r, t, e) {
        if (Vt(e)) return Kr;
        var u = A2(It, "/", e);
        if (u.b) {
            var a = u.a;
            return A5(Ht, n, A2(Qt, a, e), r, t, A2(_t, a, e));
        }
        return A5(Ht, n, "/", r, t, e);
    }), Ut = F3(function(n, r, t) {
        if (Vt(t)) return Kr;
        var e = A2(It, "?", t);
        if (e.b) {
            var u = e.a;
            return A4(Rt, n, Wr(A2(Qt, u + 1, t)), r, A2(_t, u, t));
        }
        return A4(Rt, n, Kr, r, t);
    }), Wt = F2(function(n, r) {
        if (Vt(r)) return Kr;
        var t = A2(It, "#", r);
        if (t.b) {
            var e = t.a;
            return A3(Ut, n, Wr(A2(Qt, e + 1, r)), A2(_t, e, r));
        }
        return A3(Ut, n, Kr, r);
    }), Kt = D, Gt = function(n) {
        return A2(Kt, "http://", n) ? A2(Wt, 0, A2(Qt, 7, n)) : A2(Kt, "https://", n) ? A2(Wt, 1, A2(Qt, 8, n)) : Kr;
    }, Yt = function() {
        for(;;);
    }, Jt = an, Xt = Jt(0), Zt = F4(function(n, r, t, e) {
        if (e.b) {
            var u = e.a, a = e.b;
            if (a.b) {
                var i = a.a, o = a.b;
                if (o.b) {
                    var f = o.a, c = o.b;
                    if (c.b) {
                        var s = c.b;
                        return A2(n, u, A2(n, i, A2(n, f, A2(n, c.a, t > 500 ? A3(Zr, n, r, ot(s)) : A4(Zt, n, r, t + 1, s)))));
                    }
                    return A2(n, u, A2(n, i, A2(n, f, r)));
                }
                return A2(n, u, A2(n, i, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), ne = F3(function(n, r, t) {
        return A4(Zt, n, r, 0, t);
    }), re = F2(function(n, r) {
        return A3(ne, F2(function(r, t) {
            return A2(Dr, n(r), t);
        }), b, r);
    }), te = fn, ee = F2(function(n, r) {
        return A2(te, function(r) {
            return Jt(n(r));
        }, r);
    }), ue = F3(function(n, r, t) {
        return A2(te, function(r) {
            return A2(te, function(t) {
                return Jt(A2(n, r, t));
            }, t);
        }, r);
    }), ae = function(n) {
        return A3(ne, ue(Dr), Jt(b), n);
    }, ie = yn, oe = F2(function(n, r) {
        var t = r;
        return dn(A2(te, ie(n), t));
    });
    mn.Task = kn(Xt, F3(function(n, r) {
        return A2(ee, function() {
            return 0;
        }, ae(A2(re, oe(n), r)));
    }), F3(function() {
        return Jt(0);
    }), F2(function(n, r) {
        return A2(ee, n, r);
    }));
    var fe, ce, se = An("Task"), le = F2(function(n, r) {
        return se(A2(ee, n, r));
    }), de = function(n) {
        return {
            $: 8,
            a: n
        };
    }, be = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ve = {
        $: 0
    }, he = {
        $: 0
    }, ge = {
        $: 3
    }, pe = zn, $e = F2(function(n, r) {
        return {
            aq: r,
            aC: n
        };
    }), me = un, ke = Pn("fetchQuiz", me), we = (ce = function() {
        var n, r;
        return {
            a4: (n = qr.body, r = qr.documentElement, {
                bF: Math.max(n.scrollWidth, n.offsetWidth, r.scrollWidth, r.offsetWidth, r.clientWidth),
                bn: Math.max(n.scrollHeight, n.offsetHeight, r.scrollHeight, r.offsetHeight, r.clientHeight)
            }),
            aB: {
                al: jr.pageXOffset,
                am: jr.pageYOffset,
                bF: qr.documentElement.clientWidth,
                bn: qr.documentElement.clientHeight
            }
        };
    }, on(function(n) {
        xr(function() {
            n(an(ce()));
        });
    })), ye = F5(function(n, r, t, e, u) {
        return {
            H: e,
            J: t,
            E: r,
            u: u,
            L: n
        };
    }), xe = function(n) {
        return n.b && ("" !== n.a || n.b.b) ? A2(Dr, n.a, xe(n.b)) : b;
    }, Ae = F2(function(n, r) {
        return Wr(1 === r.$ ? g([
            n
        ]) : A2(Dr, n, r.a));
    }), ze = function(n) {
        try {
            return Wr(decodeURIComponent(n));
        } catch (n) {
            return Kr;
        }
    }, Ce = f, qe = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return Kr;
            var t = r.c, e = r.d, u = r.e;
            switch(A2(Ce, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return Wr(t);
                default:
                    r = u;
                    continue n;
            }
        }
    }), je = F5(function(n, r, t, e, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), Ee = {
        $: -2
    }, Ne = F5(function(n, r, t, e, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(je, n, r, t, e, u);
            var a = e.d;
            return i = e.e, A5(je, 0, e.b, e.c, A5(je, 1, a.b, a.c, a.d, a.e), A5(je, 1, r, t, i, u));
        }
        var i, o = u.b, f = u.c, c = u.d, s = u.e;
        return -1 !== e.$ || e.a ? A5(je, n, o, f, A5(je, 0, r, t, e, c), s) : A5(je, 0, r, t, A5(je, 1, e.b, e.c, e.d, i = e.e), A5(je, 1, o, f, c, s));
    }), Se = F3(function(n, r, t) {
        if (-2 === t.$) return A5(je, 0, n, r, Ee, Ee);
        var e = t.a, u = t.b, a = t.c, i = t.d, o = t.e;
        switch(A2(Ce, n, u)){
            case 0:
                return A5(Ne, e, u, a, A3(Se, n, r, i), o);
            case 1:
                return A5(je, e, u, r, i, o);
            default:
                return A5(Ne, e, u, a, i, A3(Se, n, r, o));
        }
    }), Pe = F3(function(n, r, t) {
        var e = A3(Se, n, r, t);
        return -1 !== e.$ || e.a ? e : A5(je, 1, e.b, e.c, e.d, e.e);
    }), Fe = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, t = n.e;
                return i = t.b, o = t.c, e = t.d, s = t.e, A5(je, 1, n.b, n.c, A5(je, 0, r.b, r.c, r.d, r.e), A5(je, 0, i, o, e, s));
            }
            var e, u = n.d, a = n.e, i = a.b, o = a.c, f = (e = a.d).d, c = e.e, s = a.e;
            return A5(je, 0, e.b, e.c, A5(je, 1, n.b, n.c, A5(je, 0, u.b, u.c, u.d, u.e), f), A5(je, 1, i, o, c, s));
        }
        return n;
    }, De = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, t = n.e;
                return c = t.b, s = t.c, l = t.d, d = t.e, A5(je, 1, e = n.b, u = n.c, A5(je, 0, r.b, r.c, r.d, o = r.e), A5(je, 0, c, s, l, d));
            }
            var e = n.b, u = n.c, a = n.d, i = a.d, o = a.e, f = n.e, c = f.b, s = f.c, l = f.d, d = f.e;
            return A5(je, 0, a.b, a.c, A5(je, 1, i.b, i.c, i.d, i.e), A5(je, 1, e, u, o, A5(je, 0, c, s, l, d)));
        }
        return n;
    }, Le = F7(function(n, r, t, e, u, a, i) {
        if (-1 !== a.$ || a.a) {
            n: for(;;){
                if (-1 === i.$ && 1 === i.a) {
                    if (-1 === i.d.$) {
                        if (1 === i.d.a) return De(r);
                        break n;
                    }
                    return De(r);
                }
                break n;
            }
            return r;
        }
        return A5(je, t, a.b, a.c, a.d, A5(je, 0, e, u, a.e, i));
    }), Oe = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, t = n.b, e = n.c, u = n.d, a = u.d, i = n.e;
            if (1 === u.a) {
                if (-1 !== a.$ || a.a) {
                    var o = Fe(n);
                    if (-1 === o.$) {
                        var f = o.e;
                        return A5(Ne, o.a, o.b, o.c, Oe(o.d), f);
                    }
                    return Ee;
                }
                return A5(je, r, t, e, Oe(u), i);
            }
            return A5(je, r, t, e, Oe(u), i);
        }
        return Ee;
    }, Te = F2(function(n, r) {
        if (-2 === r.$) return Ee;
        var t = r.a, e = r.b, u = r.c, a = r.d, i = r.e;
        if (0 > o(n, e)) {
            if (-1 === a.$ && 1 === a.a) {
                var f = a.d;
                if (-1 !== f.$ || f.a) {
                    var c = Fe(r);
                    if (-1 === c.$) {
                        var s = c.e;
                        return A5(Ne, c.a, c.b, c.c, A2(Te, n, c.d), s);
                    }
                    return Ee;
                }
                return A5(je, t, e, u, A2(Te, n, a), i);
            }
            return A5(je, t, e, u, A2(Te, n, a), i);
        }
        return A2(Me, n, A7(Le, n, r, t, e, u, a, i));
    }), Me = F2(function(n, r) {
        if (-1 === r.$) {
            var t = r.a, e = r.b, u = r.c, i = r.d, o = r.e;
            if (a(n, e)) {
                var f = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(o);
                return -1 === f.$ ? A5(Ne, t, f.b, f.c, i, Oe(o)) : Ee;
            }
            return A5(Ne, t, e, u, i, A2(Te, n, o));
        }
        return Ee;
    }), Qe = F2(function(n, r) {
        var t = A2(Te, n, r);
        return -1 !== t.$ || t.a ? t : A5(je, 1, t.b, t.c, t.d, t.e);
    }), Ie = F3(function(n, r, t) {
        var e = r(A2(qe, n, t));
        return e.$ ? A2(Qe, n, t) : A3(Pe, n, e.a, t);
    }), Ve = F2(function(n, r) {
        var t = A2(Xr, "=", n);
        if (t.b && t.b.b && !t.b.b.b) {
            var e = t.b.a, u = ze(t.a);
            if (1 === u.$) return r;
            var a = u.a, i = ze(e);
            return 1 === i.$ ? r : A3(Ie, a, Ae(i.a), r);
        }
        return r;
    }), _e = Ee, Be = F2(function(n, r) {
        var t;
        return function(n) {
            n: for(;;){
                if (n.b) {
                    var r = n.a, t = r.E;
                    if (t.b) {
                        if ("" !== t.a || t.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return Wr(r.u);
                    }
                    return Wr(r.u);
                }
                return Kr;
            }
        }(n(A5(ye, b, function(n) {
            var r = A2(Xr, "/", n);
            return xe(r.b && "" === r.a ? r.b : r);
        }(r.aU), 1 === (t = r.a1).$ ? _e : A3(ne, Ve, _e, A2(Xr, "&", t.a)), r.aM, Ft)));
    }), He = {
        $: 0
    }, Re = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ue = {
        $: 1
    }, We = F2(function(n, r) {
        return A5(ye, r.L, r.E, r.J, r.H, n(r.u));
    }), Ke = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = r.L, u = r.E, a = r.J, i = r.H;
            return A2(re, We(r.u), t(A5(ye, e, u, a, i, n)));
        };
    }), Ge = F2(function(n, r) {
        return r.b ? A3(ne, Dr, r, n) : n;
    }), Ye = F2(function(n, r) {
        return A3(ne, Ge, b, A2(re, n, r));
    }), Je = function(n) {
        return function(r) {
            var t = r.L, e = r.E, u = r.J, i = r.H, o = r.u;
            if (e.b) {
                var f = e.a, c = e.b;
                return a(f, n) ? g([
                    A5(ye, A2(Dr, f, t), c, u, i, o)
                ]) : b;
            }
            return b;
        };
    }, Xe = F2(function(n, r) {
        var t = n, e = r;
        return function(n) {
            return A2(Ye, e, t(n));
        };
    }), Ze = A2(F2(function(n, r) {
        return function(n) {
            var t = n.L, e = n.E, u = n.J, a = n.H, i = n.u;
            if (e.b) {
                var o = e.a, f = e.b, c = r(o);
                if (c.$) return b;
                var s = c.a;
                return g([
                    A5(ye, A2(Dr, o, t), f, u, a, i(s))
                ]);
            }
            return b;
        };
    }), "STRING", Wr), nu = function(n) {
        return g([
            n
        ]);
    }, ru = Be((fe = g([
        A2(Ke, He, nu),
        A2(Ke, Ue, Je("quiz")),
        A2(Ke, Re, A2(Xe, Je("quiz"), Ze))
    ]), function(n) {
        return A2(Ye, function(r) {
            return r(n);
        }, fe);
    })), tu = zr, eu = F2(function(n, r) {
        return 1 === n.$ ? r : r + ":" + Yr(n.a);
    }), uu = F3(function(n, r, t) {
        return 1 === r.$ ? t : d(t, d(n, r.a));
    }), au = function(n) {
        return A3(uu, "#", n.aM, A3(uu, "?", n.a1, d(A2(eu, n.aX, d(n.a0 ? "https://" : "http://", n.aN)), n.aU)));
    }, iu = F2(function(n, r) {
        var t = function() {
            var t = ru(n);
            if (1 === t.$) return c(he, b);
            var e = t.a;
            switch(e.$){
                case 0:
                    return c(be(e), g([
                        A2(tu, r, au(n)),
                        ke("land-i-verden")
                    ]));
                case 1:
                    return c(ge, b);
                default:
                    var u = e.a;
                    return c(be(e), g([
                        A2(tu, r, au(n)),
                        ke(u)
                    ]));
            }
        }(), e = t.b;
        return c({
            ac: ve,
            S: r,
            a: t.a,
            a8: n
        }, pe(A2(Dr, A2(le, de, A2(ee, function(n) {
            var r = n.aB;
            return A2($e, $t(r.bF), $t(r.bn));
        }, we)), e)));
    }), ou = function(n) {
        switch(n.$){
            case 2:
                return "Quizleis \u2013 Geografi Quiz";
            case 4:
                return "Quizleis | Land i Verden Quiz";
            case 5:
                return "Quizleis | Stater i USA Quiz";
            default:
                return "Quizleis";
        }
    }, fu = F2(function(n, r) {
        return {
            $: 11,
            a: n,
            b: r
        };
    }), cu = function(n) {
        return {
            $: 4,
            a: n
        };
    }, su = function(n) {
        return {
            $: 4,
            a: n
        };
    }, lu = function(n) {
        return {
            $: 10,
            a: n
        };
    }, du = function(n) {
        return {
            $: 9,
            a: n
        };
    }, bu = function(n) {
        return {
            $: 5,
            a: n
        };
    }, vu = zn, hu = _, gu = V, pu = {
        $: 1
    }, $u = function(n) {
        return {
            $: 1,
            a: n
        };
    }, mu = {
        $: 0
    }, ku = {
        $: 2
    }, wu = function(n) {
        return n.toLowerCase();
    }, yu = function(n) {
        var r = ft(n);
        if (!r.$ && "" === r.a.b) return {
            $: 0,
            a: r.a.a
        };
        switch(wu(n)){
            case "backspace":
                return $u(pu);
            case "enter":
                return $u(mu);
            case "escape":
                return $u(ku);
            default:
                return $u(function(n) {
                    return {
                        $: 3,
                        a: n
                    };
                }(n));
        }
    }, xu = A2(Et, yu, A2(hu, "key", gu)), Au = function(n) {
        return !n;
    }, zu = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Cu = F3(function(n, r, t) {
        return {
            au: t,
            a3: r,
            a6: n
        };
    }), qu = Jt(A3(Cu, b, Kr, 0)), ju = function(n) {
        return on(function(r) {
            var t = n.f;
            2 === t.$ && t.c && t.c(), n.f = null, r(an(0));
        });
    }, Eu = on(function(n) {
        n(an(Date.now()));
    }), Nu = on(function(n) {
        var r = xr(function() {
            n(an(Date.now()));
        });
        return function() {
            yr(r);
        };
    }), Su = xn, Pu = dn, Fu = F3(function(n, r, t) {
        var e = t.a3, u = t.au, a = c(e, r);
        return 1 === a.a.$ ? a.b.b ? A2(te, function(n) {
            return A2(te, function(t) {
                return Jt(A3(Cu, r, Wr(n), t));
            }, Eu);
        }, Pu(A2(te, Su(n), Nu))) : qu : a.b.b ? Jt(A3(Cu, r, e, u)) : A2(te, function() {
            return qu;
        }, ju(a.a.a));
    }), Du = Ft, Lu = F3(function(n, r, t) {
        var e = t.a6, u = t.au, a = function(t) {
            return A2(ie, n, (0, t.a)(t.$ ? r - u : Du(r)));
        };
        return A2(te, function(n) {
            return A2(te, function() {
                return Jt(A3(Cu, e, Wr(n), r));
            }, ae(A2(re, a, e)));
        }, Pu(A2(te, Su(n), Nu)));
    }), Ou = F3(function(n, r, t) {
        return n(r(t));
    });
    mn["Browser.AnimationManager"] = kn(qu, Fu, Lu, 0, F2(function(n, r) {
        return r.$ ? zu(A2(Ou, n, r.a)) : {
            $: 0,
            a: A2(Ou, n, r.a)
        };
    }));
    var Tu = An("Browser.AnimationManager"), Mu = function(n) {
        return Tu(zu(n));
    }, Qu = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Iu = F2(function(n, r) {
        return {
            aW: r,
            a6: n
        };
    }), Vu = Jt(A2(Iu, b, _e)), _u = function(n) {
        return c(d(n.a ? "w_" : "d_", n.b), n);
    }, Bu = function(n) {
        return A3(Zr, F2(function(n, r) {
            return A3(Pe, n.a, n.b, r);
        }), _e, n);
    }, Hu = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.e, u = n, a = A3(n, t.b, t.c, A3(Hu, n, r, t.d));
            n = u, r = a, t = e;
        }
    }), Ru = F6(function(n, r, t, e, u, a) {
        var i = A3(Hu, F3(function(e, u, a) {
            n: for(;;){
                var i = a.a, f = a.b;
                if (i.b) {
                    var s = i.a, l = s.a, d = s.b, b = i.b;
                    if (0 > o(l, e)) {
                        a = c(b, A3(n, l, d, f));
                        continue n;
                    }
                    return o(l, e) > 0 ? c(i, A3(t, e, u, f)) : c(b, A4(r, l, d, u, f));
                }
                return c(i, A3(t, e, u, f));
            }
        }), c(Or(e), a), u), f = i.a, s = i.b;
        return A3(Zr, F2(function(r, t) {
            return A3(n, r.a, r.b, t);
        }), s, f);
    }), Uu = F2(function(n, r) {
        return {
            aL: r,
            aP: n
        };
    }), Wu = F3(function(n, r, t) {
        return A2(ee, function(n) {
            return c(r, n);
        }, A3(Er, t.a ? jr : qr, t.b, function(t) {
            return A2(Su, n, A2(Uu, r, t));
        }));
    }), Ku = F2(function(n, r) {
        return A3(Hu, Pe, r, n);
    }), Gu = F3(function(n, r, t) {
        var e = F3(function(r, t, e) {
            var u = e.c;
            return s(e.a, e.b, A2(Dr, A3(Wu, n, r, t), u));
        }), u = F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return s(A2(Dr, r, t.a), e, u);
        }), a = F4(function(n, r, t, e) {
            var u = e.c;
            return s(e.a, A3(Pe, n, r, e.b), u);
        }), i = A2(re, _u, r), o = A6(Ru, u, a, e, t.aW, Bu(i), s(b, _e, b)), f = o.b, c = o.c;
        return A2(te, function(n) {
            return Jt(A2(Iu, i, A2(Ku, f, Bu(n))));
        }, A2(te, function() {
            return ae(c);
        }, ae(A2(re, ju, o.a))));
    }), Yu = F3(function(n, r, t) {
        var e = n(r);
        return e.$ ? t : A2(Dr, e.a, t);
    }), Ju = F2(function(n, r) {
        return A3(ne, Yu(n), b, r);
    });
    mn["Browser.Events"] = kn(Vu, Gu, F3(function(n, r, t) {
        var e = r.aP, u = r.aL, i = A2(Ju, function(n) {
            var r = n.b.c;
            return a(n.a, e) ? A2(Nr, r, u) : Kr;
        }, t.a6);
        return A2(te, function() {
            return Jt(t);
        }, ae(A2(re, ie(n), i)));
    }), 0, F2(function(n, r) {
        return A3(Qu, r.a, r.b, A2(Et, n, r.c));
    }));
    var Xu, Zu = An("Browser.Events"), na = F3(function(n, r, t) {
        return Zu(A3(Qu, n, r, t));
    }), ra = A2(na, 0, "keydown"), ta = I, ea = Ln("onReceiveBoundingRect", ta), ua = function(n) {
        return {
            $: 1,
            a: n
        };
    }, aa = F2(function(n, r) {
        var t = n.a5;
        if (1 === t.$) {
            var e = t.a, u = e.G;
            return 1 === u.$ ? n : l(n, {
                a5: ua(l(e, {
                    G: Wr({
                        Q: u.a.Q,
                        af: Wr(r)
                    })
                }))
            });
        }
        return n;
    }), ia = M, oa = Ln("quizNotFound", gu), fa = Ln("receiveQuiz", ta), ca = function(n) {
        return {
            $: 2,
            a: n
        };
    }, sa = {
        $: 0
    }, la = function(n) {
        return {
            $: 5,
            a: n
        };
    }, da = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), ba = cn, va = F2(function(n, r) {
        return se(A2(ba, A2(Ou, A2(Ou, Jt, n), Ir), A2(te, A2(Ou, A2(Ou, Jt, n), Hr), r)));
    }), ha = Q, ga = K, pa = F2(function(n, r) {
        return {
            al: n,
            am: r
        };
    }), $a = F2(function(n, r) {
        return {
            aD: r,
            aF: n
        };
    }), ma = x, ka = A5(ga, F4(function(n, r, t, e) {
        return A2($a, A2(pa, ma(n), ma(r)), A2($e, ma(t), ma(e)));
    }), A2(hu, "x", ha), A2(hu, "y", ha), A2(hu, "width", ha), A2(hu, "height", ha)), wa = Y, ya = function(n) {
        return {
            $: 2,
            a: n
        };
    }, xa = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Aa = F2(function(n, r) {
        return {
            bi: n,
            bs: r
        };
    }), za = F2(function(n, r) {
        return {
            bi: n,
            bs: r
        };
    }), Ca = F2(function(n, r) {
        return {
            bj: r,
            bB: n
        };
    }), qa = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ja = F3(function(n, r, t) {
        return {
            bi: r,
            bs: t,
            bD: n
        };
    }), Ea = H, Na = F2(function(n, r) {
        return A3(ne, hu, r, n);
    }), Sa = A3(Nt, $e, A2(hu, "w", ia), A2(hu, "h", ia)), Pa = function(n) {
        return {
            $: 3,
            b: n
        };
    }, Fa = function(n) {
        return {
            $: 5,
            c: n
        };
    }, Da = function(n) {
        return {
            $: 11,
            g: n
        };
    }, La = {
        $: 0
    }, Oa = {
        $: 1
    }, Ta = {
        $: 2
    }, Ma = {
        $: 3
    }, Qa = {
        $: 5
    }, Ia = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Va = {
        $: 4
    }, _a = function(n) {
        switch(n){
            case "Africa":
                return Ia(La);
            case "Asia":
                return Ia(Oa);
            case "Europe":
                return Ia(Ta);
            case "North America":
                return Ia(Ma);
            case "South America":
                return Ia(Va);
            case "Oceania":
                return Ia(Qa);
            case "Europe&Asia":
                return {
                    $: 1,
                    a: c(Oa, Ta)
                };
            default:
                return Ia(function(n) {
                    return {
                        $: 6,
                        a: n
                    };
                }(n));
        }
    }, Ba = A7(G, F6(function(n, r, t, e, u, a) {
        return {
            an: e,
            aI: a,
            P: n,
            y: r,
            aV: t,
            av: u
        };
    }), A2(hu, "id", gu), A2(hu, "name", gu), A2(hu, "paths", Pa(gu)), A2(hu, "area", Da(g([
        ia,
        Fa(0)
    ]))), A2(hu, "population", Da(g([
        ia,
        Fa(0)
    ]))), A2(Et, _a, A2(hu, "continent", Da(g([
        gu,
        Fa("unknown")
    ]))))), Ha = F2(function(n, r) {
        return {
            bd: r,
            y: n
        };
    }), Ra = A3(Nt, $a, A2(hu, "origin", A3(Nt, pa, A2(hu, "x", ia), A2(hu, "y", ia))), A3(Nt, $e, A2(hu, "w", ia), A2(hu, "h", ia))), Ua = A3(Nt, Ha, A2(hu, "title", gu), A2(hu, "boundingBox", Ra)), Wa = F3(function(n, r, t) {
        return {
            P: n,
            y: r,
            aV: t
        };
    }), Ka = W, Ga = function(n) {
        return g([
            n
        ]);
    }, Ya = A2(Et, Ga, gu), Ja = A4(Ka, Wa, A2(hu, "id", gu), A2(hu, "name", gu), A2(hu, "paths", Da(g([
        Pa(gu),
        Ya
    ])))), Xa = A2(Ea, function(n) {
        switch(n){
            case "static":
                return A3(Nt, Ca, St("Title"), A2(Et, qa, A4(Ka, ja, A2(Na, g([
                    "image",
                    "uri"
                ]), gu), A2(Na, g([
                    "image",
                    "dimensions"
                ]), Sa), A2(hu, "items", Pa(Ua)))));
            case "dynamic":
                return A3(Nt, Ca, St("Title"), A2(Et, xa, A3(Nt, za, A2(Na, g([
                    "image",
                    "dimensions"
                ]), Sa), A2(hu, "items", Pa(Ba)))));
            case "dynamic/us-states":
                return A3(Nt, Ca, St("Title"), A2(Et, ya, A3(Nt, Aa, A2(Na, g([
                    "image",
                    "dimensions"
                ]), Sa), A2(hu, "items", Pa(Ja)))));
            default:
                return {
                    $: 1,
                    a: '"display": ' + n + " not supported"
                };
        }
    }, A2(hu, "display", gu)), Za = Sr("focus"), ni = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ri = function(n) {
        var r = n.b;
        return A2(ni, 1664525 * n.a + r >>> 0, r);
    }, ti = (Xu = Du, on(function(n) {
        n(an(Xu(Date.now())));
    })), ei = A2(te, function(n) {
        var r, t;
        return Jt((r = n, t = ri(A2(ni, 0, 1013904223)), ri(A2(ni, t.a + r >>> 0, t.b))));
    }, ti), ui = F2(function(n, r) {
        return n(r);
    }), ai = F3(function(n, r, t) {
        if (r.b) {
            var e = r.b, u = A2(ui, r.a, t), a = u.b;
            return A2(te, function() {
                return A3(ai, n, e, a);
            }, A2(ie, n, u.a));
        }
        return Jt(t);
    }), ii = F3(function(n, r, t) {
        return Jt(t);
    }), oi = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r), u = e.b;
            return c(n(e.a), u);
        };
    });
    mn.Random = kn(ei, ai, ii, F2(function(n, r) {
        return A2(oi, n, r);
    }));
    var fi, ci, si, li, di, bi, vi = An("Random"), hi = F2(function(n, r) {
        return vi(A2(oi, n, r));
    }), gi = Pn("getBoundingRect", me), pi = {
        $: 0
    }, $i = {
        $: 0
    }, mi = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ki = {
        q: {
            r: mi(5)
        }
    }, wi = F2(function(n, r) {
        return A3(ne, F2(function(r, t) {
            return n(r) ? A2(Dr, r, t) : t;
        }), b, r);
    }), yi = F3(function(n, r, t) {
        return r(n(t));
    }), xi = q, Ai = F2(function(n, r) {
        var t = r.b;
        return c(n(r.a), t);
    }), zi = F4(function(n, r, t, e) {
        return {
            bq: r,
            aQ: n,
            bu: t,
            bz: e
        };
    }), Ci = Pr, qi = function(n) {
        return A2(Ci, {
            bf: !1,
            bt: !1
        }, n);
    }, ji = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), Ei = A2(yi, qi, ji(/.^/)), Ni = (fi = g([
        c("[\xe0-\xe6]", "a"),
        c("[\xc0-\xc6]", "A"),
        c("\xe7", "c"),
        c("\xc7", "C"),
        c("[\xe8-\xeb]", "e"),
        c("[\xc8-\xcb]", "E"),
        c("[\xec-\xef]", "i"),
        c("[\xcc-\xcf]", "I"),
        c("\xf1", "n"),
        c("\xd1", "N"),
        c("[\xf2-\xf6]", "o"),
        c("[\xd2-\xd6]", "O"),
        c("[\xf9-\xfc]", "u"),
        c("[\xd9-\xdc]", "U"),
        c("\xfd", "y"),
        c("\xff", "y"),
        c("\xdd", "Y")
    ]), A2(re, Ai(Ei), fi)), Si = Fr(1 / 0), Pi = function(n) {
        return Vt(n) ? n : A3(Zr, function(n) {
            var r = n.b;
            return A2(Si, n.a, function() {
                return r;
            });
        }, n, Ni);
    }, Fi = A2(yi, wu, A2(yi, Pi, xi(function(n) {
        return function(n) {
            var r = at(n);
            return r >= 97 && 122 >= r;
        }(n) || function(n) {
            var r = at(n);
            return 90 >= r && r >= 65;
        }(n);
    }))), Di = {
        $: 0
    }, Li = {
        $: 0
    }, Oi = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ti = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Mi = {
        q: {
            w: Ti(Oi(10)),
            C: Li,
            k: 50
        }
    }, Qi = function(n) {
        return {
            bi: n.bi,
            bs: n.bs,
            q: {
                w: Wr(Mi.q.w),
                C: Mi.q.C,
                k: Wr(Mi.q.k)
            },
            a5: Di
        };
    }, Ii = pe(b), Vi = {
        $: 0
    }, _i = C, Bi = function(n) {
        return A2(_i, n, "");
    }, Hi = function(n) {
        return l(n, {
            a5: 0
        });
    }, Ri = F2(function(n, r) {
        var t = r.a5;
        if (1 === t.$) {
            var e = t.a;
            if (e.A.$) {
                if (n.$) return r;
                var u = n.a;
                return l(r, {
                    a5: ua(l(e, {
                        s: Hi(e.s),
                        I: Bi(u),
                        A: Vi
                    }))
                });
            }
            return 1 === n.$ && 2 === n.a.$ ? l(r, {
                a5: ua(l(e, {
                    I: ""
                }))
            }) : r;
        }
        return r;
    }), Ui = function(n) {
        var r = n.a, t = 277803737 * (r ^ r >>> 4 + (r >>> 28));
        return (t >>> 22 ^ t) >>> 0;
    }, Wi = F2(function(n, r) {
        return function(t) {
            var e = 0 > o(n, r) ? c(n, r) : c(r, n), u = e.a, a = e.b - u + 1;
            if (a - 1 & a) {
                var i = (-a >>> 0) % a >>> 0;
                return function(n) {
                    for(;;){
                        var r = Ui(n), t = ri(n);
                        if (o(r, i) >= 0) return c(r % a + u, t);
                        n = t;
                    }
                }(t);
            }
            return c(((a - 1 & Ui(t)) >>> 0) + u, ri(t));
        };
    }), Ki = A2(Wi, -2147483648, 2147483647), Gi = F4(function(n, r, t, e) {
        var u = r, a = t, i = e;
        return function(r) {
            var t = u(r), e = t.a, o = a(t.b), f = o.a, s = i(o.b), l = s.b;
            return c(A3(n, e, f, s.a), l);
        };
    }), Yi = function(n) {
        var r = F3(function(n, r, t) {
            return ri(A2(ni, n, (1 | r ^ t) >>> 0));
        }), t = A2(Wi, 0, 4294967295);
        return A2(ui, A4(Gi, r, t, t, t), n);
    }, Ji = function(n) {
        return n.b;
    }, Xi = m, Zi = F2(function(n, r) {
        var t = r, e = t.ak, u = t.M;
        if (1 === t.a5) return c(r, !1);
        var a = n + u, i = o(e, a) > 0 ? c(a, !1) : c(a - e, !0), f = i.b;
        return c(l(t, {
            M: i.a
        }), f);
    }), no = F2(function(n, r) {
        var t, e = r.a5;
        if (1 === e.$) {
            var u = e.a, a = A2(Zi, n, u.s);
            return l(r, a.b ? {
                a5: (t = u.O, {
                    $: 2,
                    a: t
                })
            } : {
                a5: ua(l(u, {
                    s: a.a
                }))
            });
        }
        return r;
    }), ro = function(n) {
        return {
            $: 1,
            a: n
        };
    }, to = function(n) {
        return {
            $: 0,
            a: n
        };
    }, eo = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return Kr;
            var e = t.b;
            if (r(t.a)) return Wr(n);
            n += 1, t = e;
        }
    }), uo = eo(0), ao = function(n) {
        switch(n.$){
            case 1:
            case 3:
            case 2:
            case 5:
                return !0;
            default:
                return !1;
        }
    }, io = function(n) {
        return function(r) {
            switch(r.$){
                case 1:
                case 3:
                case 2:
                default:
                    return r.a;
                case 4:
                    return t = r.a, n ? t.b : t.a;
                case 5:
                    var t;
                    return (t = r.a).a;
            }
        };
    }, oo = function(n) {
        var r = n, t = A2(uo, A2(Ou, Au, ao), r);
        if (1 === t.$) return r;
        var e = t.a;
        return A2(ut, F2(function(n, r) {
            return o(e, n) > 0 ? r : a(n, e) ? {
                $: 2,
                a: A2(io, !1, r)
            } : 5 === r.$ ? r : to(A2(io, !1, r));
        }), r);
    }, fo = F2(function(n, r) {
        var t, e = r.a5;
        if (1 === e.$) {
            var u = e.a, a = u.m, i = u.W, o = A2(Zi, n, i), f = o.a;
            return l(r, o.b ? {
                a5: ro(l(u, {
                    W: (t = i, l(t, {
                        M: 0
                    })),
                    m: l(a, {
                        n: oo(a.n)
                    })
                }))
            } : {
                a5: ro(l(u, {
                    W: f
                }))
            });
        }
        return r;
    }), co = Pn("updateMetaDescription", me), so = F2(function(n, r) {
        var t, e, u, a = r.a;
        switch(n.$){
            case 0:
                return c(r, Ii);
            case 1:
                var i = n.a;
                return c(l(r, {
                    a: su(n.b)
                }), function() {
                    switch(i.$){
                        case 0:
                            return Ii;
                        case 1:
                            return A2(va, function() {
                                return sa;
                            }, Za(i.a));
                        default:
                            return gi(i.a);
                    }
                }());
            case 2:
                return i = n.a, c(l(r, {
                    a: la(n.b)
                }), function() {
                    switch(i.$){
                        case 0:
                        case 1:
                            return Ii;
                        default:
                            var n = i.b;
                            return A2(hi, da(i.a), (r = n, A2(oi, function(n) {
                                return A2(re, xt, A2(Xi, Ji, A3(Zr, F2(function(n, r) {
                                    var t = r.a, e = A2(ui, Ki, r.b), u = e.b;
                                    return c(A2(Dr, c(n, e.a), t), u);
                                }), c(b, n), r).a));
                            }, Yi)));
                    }
                    var r;
                }());
            case 3:
                var o = (0, n.a)(n.b);
                return i = o.b, c(l(r, {
                    a: la(o.a)
                }), 1 === i.$ ? A2(va, function() {
                    return sa;
                }, Za(i.a)) : Ii);
            case 4:
                return 4 === a.$ ? c(l(r, {
                    a: su(A2(Ri, n.a, a.a))
                }), A2(va, function() {
                    return sa;
                }, Za("guess-input"))) : c(r, Ii);
            case 5:
                var f = n.a;
                switch(a.$){
                    case 2:
                        var s = a.a;
                        return c(l(r, {
                            a: ca(l(s, {
                                aA: 1 + s.aA
                            }))
                        }), Ii);
                    case 4:
                        return c(l(r, {
                            a: su(A2(no, f, a.a))
                        }), Ii);
                    case 5:
                        return c(l(r, {
                            a: la(A2(fo, f, a.a))
                        }), Ii);
                    default:
                        return c(r, Ii);
                }
            case 6:
                var d = n.a;
                if (d.$) return c(r, Ii);
                var v = ru(p = d.a);
                if (1 === v.$) return c(r, A2(tu, r.S, au(p)));
                switch((w = v.a).$){
                    case 0:
                    case 1:
                        return c(r, A2(tu, r.S, au(p)));
                    default:
                        var h = w.a;
                        return c(r, A2(tu, r.S, au(p)));
                }
            case 7:
                var p, $ = ru(p = n.a);
                if (1 === $.$) return c(l(r, {
                    a: he
                }), Ii);
                switch((w = $.a).$){
                    case 0:
                        return c(l(r, {
                            a: be(w)
                        }), pe(g([
                            ke("land-i-verden"),
                            co("Quizleis har spill som vil quizze deg innen bl a geografi. Klarer du fylle verdenskartet, eller navngi delstatene i USA?")
                        ])));
                    case 1:
                        return c(l(r, {
                            a: ge
                        }), co("Quizleis har spill som vil quizze deg innen bl a geografi. Klarer du fylle verdenskartet, eller navngi delstatene i USA?"));
                    default:
                        return h = w.a, c(l(r, {
                            a: be(w)
                        }), pe(g([
                            ke(h),
                            co(function() {
                                switch(h){
                                    case "land-i-verden":
                                        return "En morsom og litt annerledes geografi quiz. Best\xe5r av alle verdens land \u2014 eller begrens omr\xe5det til et kontinent (Europa, Afrika, Asia etc). Fyll kartet med land!";
                                    case "stater-i-usa":
                                        return "Kan du navnet p\xe5 delstater i USA? En quiz der du finner ut hvilke stater i USA du klarer plassere, og som vil hjelpe deg videre ved \xe5 gi hint p\xe5 de du stusser litt p\xe5.";
                                    default:
                                        return "Quizleis har spill som vil quizze deg innen bl a geografi. Klarer du fylle verdenskartet, eller navngi delstatene i USA?";
                                }
                            }())
                        ])));
                }
            case 8:
                return c(l(r, {
                    ac: (u = {
                        aB: n.a
                    }, {
                        $: 1,
                        a: u
                    })
                }), Ii);
            case 9:
                var m = n.a;
                if (1 === (x = A2(wa, A2(hu, "data", Xa), m)).$) return c(1 === a.$ ? l(r, {
                    a: he
                }) : r, Ii);
                var k = x.a.bj;
                switch(k.$){
                    case 1:
                        var w, y = k.a;
                        return c(1 === a.$ ? l(r, (w = a.a).$ ? {
                            a: su((t = y, {
                                bi: t.bi,
                                bs: Bu(A2(re, function(n) {
                                    return c(Fi(n.y), n);
                                }, A2(wi, function(n) {
                                    var r;
                                    return !(!(r = n.aI).$ && 6 === r.a.$);
                                }, t.bs))),
                                q: {
                                    C: pi,
                                    r: Wr(ki.q.r)
                                },
                                a5: $i
                            }))
                        } : {
                            a: ca((e = y, {
                                ao: e,
                                aA: 0
                            }))
                        }) : r, Ii);
                    case 2:
                        return c(l(r, {
                            a: la(Qi(k.a))
                        }), Ii);
                    default:
                        return c(r, Ii);
                }
            case 10:
                return c(1 === a.$ ? l(r, {
                    a: he
                }) : r, Ii);
            default:
                var x, A = n.a;
                return 1 === (x = A2(wa, ka, m = n.b)).$ ? c(r, Ii) : c(l(r, {
                    a: A(x.a)
                }), Ii);
        }
    }), lo = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), bo = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), vo = Vn, ho = vo, go = function(n) {
        return "rgb(183,212,249," + Yr(n) + ")";
    }, po = O, $o = function(n) {
        return "rgba(173,216,230," + po(n) + ")";
    }, mo = Bn("div"), ko = ho(""), wo = Un, yo = wo, xo = Bn("a"), Ao = Bn("h1"), zo = F2(function(n, r) {
        return A2(Wn, n, me(r));
    }), Co = function(n) {
        var r;
        return A2(zo, "href", Yn.test(r = n) ? "" : r);
    }, qo = Bn("li"), jo = F2(function(n, r) {
        return 0 > o(n, r) ? n : r;
    }), Eo = Bn("p"), No = A2(yi, Yr, function(n) {
        return n + "px";
    }), So = Bn("ul"), Po = {
        $: 0
    }, Fo = function(n) {
        return A2(zo, "autocomplete", n ? "on" : "off");
    }, Do = Bn("button"), Lo = F3(function(n, r, t) {
        return 0 > o(t, n) ? n : o(t, r) > 0 ? r : t;
    }), Oo = zo("className"), To = F2(function(n, r) {
        return a(Fi(n), Fi(r));
    }), Mo = function(n) {
        switch(n.$){
            case 0:
                return A2($a, A2(pa, 1138, 426), A2($e, 524, 650));
            case 1:
                return A2($a, A2(pa, 1459, 100), A2($e, 1e3, 800));
            case 2:
                return A2($a, A2(pa, 1140, 150), A2($e, 400, 300));
            case 3:
                return A2($a, A2(pa, 200, 100), A2($e, 1e3, 600));
            case 4:
                return A2($a, A2(pa, 500, 620), A2($e, 600, 640));
            case 5:
                return A2($a, A2(pa, 2050, 800), A2($e, 700, 400));
            default:
                return A2($a, A2(pa, 0, 0), A2($e, 2600, 1300));
        }
    }, Qo = Oo(A2(Jr, " ", A2(re, xt, A2(wi, Ji, b)))), Io = function(n) {
        switch(n.a5.$){
            case 1:
            case 2:
                return l(n, {
                    a5: $i
                });
            default:
                return n;
        }
    }, Vo = F3(function(n, r, t) {
        return 1 === t ? "ett " + n : Yr(t) + " " + r;
    }), _o = function(n) {
        return n.b ? Wr(n.a) : Kr;
    }, Bo = zo("id"), Ho = Bn("input"), Ro = g([
        {
            P: La,
            y: "Africa"
        },
        {
            P: Oa,
            y: "Asia"
        },
        {
            P: Ta,
            y: "Europe"
        },
        {
            P: Ma,
            y: "North America"
        },
        {
            P: Va,
            y: "South America"
        },
        {
            P: Qa,
            y: "Oceania"
        }
    ]), Uo = F2(function(n, r) {
        return r.$ ? Kr : Wr(n(r.a));
    }), Wo = Rn, Ko = F2(function(n, r) {
        return A2(Wo, n, {
            $: 0,
            a: r
        });
    }), Go = function(n) {
        return A2(Ko, "click", St(n));
    }, Yo = F2(function(n, r) {
        return A2(Wo, n, {
            $: 1,
            a: r
        });
    }), Jo = F2(function(n, r) {
        return A2(Qe, n, r);
    }), Xo = F2(function(n, r) {
        for(;;){
            if (-2 === r.$) return n;
            var t = r.d;
            n = A2(Xo, n + 1, r.e), r = t;
        }
    }), Zo = function(n) {
        return A2(Xo, 0, n);
    }, nf = F2(function(n, r) {
        var t = n.bs, e = n.a5;
        if (1 === e.$) {
            var u = e.a, a = u.ae, i = u.O, f = Fi(r), c = A2(Jo, f, a);
            return o(Zo(a), Zo(c)) > 0 ? l(n, {
                a5: ua(l(u, {
                    O: A2(ji, i, A2(Uo, function(n) {
                        return A2(Dr, n, i);
                    }, A2(qe, f, t))),
                    I: "",
                    ae: A2(Jo, Fi(r), a)
                }))
            }) : l(n, {
                a5: ua(l(u, {
                    I: r
                }))
            });
        }
        return n;
    }), rf = function(n) {
        return c(n, !0);
    }, tf = A2(Na, g([
        "target",
        "value"
    ]), gu), ef = function(n) {
        return A2(Yo, "input", A2(Et, rf, A2(Et, n, tf)));
    }, uf = Bn("option"), af = Bn("select"), of = Bn("span"), ff = un, cf = F2(function(n, r) {
        return A2(Wn, n, ff(r));
    }), sf = cf("spellcheck"), lf = F2(function(n, r) {
        return A3(Hu, F3(function(r, t, e) {
            return A2(n, r, t) ? A3(Pe, r, t, e) : e;
        }), _e, r);
    }), df = _e, bf = F2(function(n, r) {
        return A3(Pe, n, 0, r);
    }), vf = function(n) {
        return {
            M: 0,
            a5: 0,
            ak: n
        };
    }, hf = F2(function(n, r) {
        if (n.$) {
            var t = n.a, e = t.b;
            return a(r.P, t.a) || a(r.P, e);
        }
        return a(r.P, n.a);
    }), gf = F2(function(n, r) {
        var t, e, u, a, i = r.bs, o = r.q;
        return r.a5.$ ? r : l(r, {
            a5: ua({
                s: (e = vf((u = A2(ji, ki.q.r, o.r), u.$ ? 3e5 : 60 * u.a * 1e3)), l(e, {
                    a5: 1
                })),
                G: Kr,
                O: b,
                I: n,
                ae: (a = A2(lf, F2(function(n, r) {
                    var t = o.C;
                    return !t.$ || A2(hf, r.aI, t.a);
                }), i), t = A3(Lr, F3(function(n, r, t) {
                    return A2(Dr, n, t);
                }), b, a), A3(Zr, bf, df, t)),
                A: {
                    $: 1,
                    a: 0
                }
            })
        });
    }), pf = Bn("sup"), $f = function(n) {
        switch(n.$){
            case 0:
                return "Afrika";
            case 1:
                return "Asia";
            case 2:
                return "Europa";
            case 3:
                return "Nord-Amerika";
            case 4:
                return "S\xf8r-Amerika";
            case 5:
                return "Oseania";
            default:
                return "Ukjent: " + n.a;
        }
    }, mf = function(n) {
        return {
            $: 2,
            a: n
        };
    }, kf = F5(function(n, r, t, e, u) {
        return {
            bh: t,
            aO: r,
            aT: n,
            ag: e,
            ai: u
        };
    }), wf = function(n) {
        return A2(Jr, "", n);
    }, yf = function(n) {
        return 0 > n ? -n : n;
    }, xf = F3(function(n, r, t) {
        return n > 0 ? A3(xf, n >> 1, d(r, r), 1 & n ? d(t, r) : t) : t;
    }), Af = F2(function(n, r) {
        return A3(xf, n, r, "");
    }), zf = F2(function(n, r) {
        var t = Tt(r), e = 0 > o(t, n) ? yf(n - t) : 0;
        return d(r, A2(Af, e, "0"));
    }), Cf = F2(function(n, r) {
        return 1 > n ? r : A3(Mt, 0, -n, r);
    }), qf = F2(function(n, r) {
        return 1 > n ? "" : A3(Mt, -n, Tt(r), r);
    }), jf = function(n) {
        return "0" !== A2(qf, 1, n) ? n : jf(A2(Cf, 1, n));
    }, Ef = F2(function(n, r) {
        var t = n.bh;
        switch(t.$){
            case 1:
                return jf(r);
            case 2:
                return r;
            default:
                return A2(zf, t.a, r);
        }
    }), Nf = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), Sf = j, Pf = function(n) {
        return A3(Sf, Dr, b, n);
    }, Ff = F2(function(n, r) {
        var t = A2(Nf, function(n) {
            return "0" !== n && "." !== n;
        }, Pf(r));
        return d(n && t ? "-" : "", r);
    }), Df = function(n) {
        return 0 > n || n > 1114111 ? "\uFFFD" : n > 65535 ? String.fromCharCode(Math.floor((n -= 65536) / 1024) + 55296, n % 1024 + 56320) : String.fromCharCode(n);
    }, Lf = function(n) {
        var r = n.a, t = n.b;
        if ("9" === r) {
            var e = ft(t);
            return 1 === e.$ ? "01" : A2(_i, "0", Lf(e.a));
        }
        var u = at(r);
        return u >= 48 && 57 > u ? A2(_i, Df(u + 1), t) : "0";
    }, Of = z, Tf = F3(function(n, r, t) {
        return d(t, A2(Af, n - Tt(t), Bi(r)));
    }), Mf = function(n) {
        for(var r = n.length, t = Array(r), e = 0; r > e;){
            var u = n.charCodeAt(e);
            55296 > u || u > 56319 ? (t[r - e] = n[e], e++) : (t[r - e] = n[e + 1], t[r - ++e] = n[e - 1], e++);
        }
        return t.join("");
    }, Qf = function(n) {
        var r = A2(Xr, ".", n);
        return r.b ? c(r.a, r.b.b ? r.b.a : "0") : c("0", "0");
    }, If = F3(function(n, r, t) {
        if ((e = t) === 1 / 0 || e === -1 / 0 || Of(t)) return po(t);
        var e, u = 0 > t, a = Qf(function(n) {
            var r = A2(Xr, "e", po(yf(n)));
            if (r.b) {
                if (r.b.b) {
                    var t = r.a, e = r.b.a, u = A2(ji, 0, Bt(A2(Kt, "+", e) ? A2(Qt, 1, e) : e)), a = Qf(t), i = d(a.a, a.b), o = 0 > u ? A2(ji, "0", A2(Uo, function(n) {
                        return n.a + "." + n.b;
                    }, A2(Uo, Ai(Bi), ft(d(A2(Af, yf(u), "0"), i))))) : A3(Tf, u + 1, "0", i);
                    return d(0 > n ? "-" : "", o);
                }
                return d(0 > n ? "-" : "", t = r.a);
            }
            return "";
        }(yf(t))), i = a.a, f = a.b, c = Tt(i) + r, s = d(A2(Af, 1 - c, "0"), A3(Tf, c, "0", d(i, f))), l = Tt(s), b = A2(kt, 1, c), v = A2(n, u, A3(Mt, b, l, s)), h = A3(Mt, 0, b, s), g = v ? Mf(A2(ji, "1", A2(Uo, Lf, ft(Mf(h))))) : h, p = Tt(g), $ = "0" === g ? g : r > 0 ? 0 > o(r, Tt(f)) ? A3(Mt, 0, p - r, g) + "." + A3(Mt, p - r, p, g) : d(i + ".", A3(Tf, r, "0", f)) : d(g, A2(Af, yf(r), "0"));
        return A2(Ff, u, $);
    })(F2(function(n, r) {
        var t, e = ft(r);
        return 1 !== e.$ && ("5" === e.a.a ? "" !== e.a.b || !n : (t = at(e.a.a)) > 53 && n || t >= 53 && !n);
    })), Vf = F2(function(n, r) {
        var t, e, u = function() {
            var r = n.bh;
            switch(r.$){
                case 1:
                default:
                    return If(r.a);
                case 0:
                    return po;
            }
        }(), a = A2(Xr, ".", u(r)), i = (e = (t = a).b ? Wr(t.b) : Kr).$ ? "" : A2(ji, "", _o(e.a));
        return c(A2(ji, "", _o(a)), i);
    }), _f = F2(function(n, r) {
        return n ? function(n) {
            var r = Tt(n) > 3 ? A2(qf, 3, n) : n, t = function(n) {
                return Tt(n) > 2 ? A2(Dr, A2(qf, 2, n), t(A2(Cf, 2, n))) : Tt(n) ? g([
                    n
                ]) : b;
            };
            return ot(A2(Dr, r, t(A2(Cf, 3, n))));
        }(A2(xi, it, r)) : function(n) {
            var r = function(n) {
                return Tt(n) > 3 ? A2(Dr, A2(qf, 3, n), r(A2(Cf, 3, n))) : g([
                    n
                ]);
            };
            return ot(r(n));
        }(A2(xi, it, r));
    }), Bf = F2(function(n, r) {
        var t, e = A2(Vf, n, r), u = A5(kf, r, A2(_f, n.aj, A2(xi, it, e.a)), A2(Ef, n, e.b), "", "");
        switch(A2(Gr, function(n) {
            return "0" === n;
        }, wf(A2(Ge, (t = u).aO, Ga(t.bh)))) ? 1 : 0 > t.aT ? 2 : 0){
            case 2:
                return l(u, {
                    ag: n.as,
                    ai: n.at
                });
            case 0:
                return l(u, {
                    ag: n.aY,
                    ai: n.aZ
                });
            default:
                return l(u, {
                    ag: n.ba,
                    ai: n.bb
                });
        }
    }), Hf = F2(function(n, r) {
        return "" === r ? "" : d(n.F, r);
    }), Rf = F2(function(n, r) {
        var t = Hf(n), e = A2(Jr, n.D, r.aO), u = t(r.bh);
        return wf(g([
            r.ag,
            e,
            u,
            r.ai
        ]));
    }), Uf = F2(function(n, r) {
        return A2(Rf, n, A2(Bf, n, r));
    }), Wf = l({
        F: ".",
        bh: {
            $: 0,
            a: 0
        },
        as: "\u2212",
        at: "",
        aY: "",
        aZ: "",
        aj: 0,
        D: "",
        ba: "",
        bb: ""
    }, {
        F: ",",
        bh: mf(3),
        D: "\u202F"
    }), Kf = A2(yi, vt, Uf(l(Wf, {
        bh: mf(0)
    }))), Gf = function(n) {
        return Bi(Df(function() {
            switch(n){
                case 0:
                    return 128241;
                case 1:
                    return 9e3;
                case 2:
                    return 128187;
                case 3:
                    return 128421;
                case 4:
                    return 129395;
                case 5:
                    return 128512;
                case 7:
                    return 128077;
                case 8:
                    return 11015;
                case 9:
                    return 128071;
                default:
                    return 129300;
            }
        }()));
    }, Yf = zo("type"), Jf = function(n) {
        return n.$ ? 0 : n.a;
    }, Xf = zo("value"), Zf = F3(function(n, r, t) {
        return d(A2(Af, n - Tt(t), Bi(r)), t);
    }), nc = A2(yi, function(n) {
        return n.ak - n.M;
    }, A2(yi, function(n) {
        var r = $t(n) / 6e4 | 0, t = ($t(n) - 6e4 * r) / 1e3 | 0;
        return s(r, t, $t(n) - 6e4 * r - 1e3 * t);
    }, function(n) {
        var r = n.b, t = n.c;
        return ho(A3(Zf, 2, "0", Yr(n.a)) + ":" + A3(Zf, 2, "0", Yr(r)) + "." + A3(Zf, 3, "0", Yr(t)));
    })), rc = function(n) {
        var r = n.aF, t = n.aD;
        return Yr(r.al) + " " + Yr(r.am) + " " + Yr(t.aC) + " " + Yr(t.aq);
    }, tc = _n("http://www.w3.org/2000/svg"), ec = tc("svg"), uc = Kn("viewBox"), ac = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ic = Kn("d"), oc = Kn("fill"), fc = tc("g"), cc = Kn("id"), sc = function(n) {
        return A2(Ko, "mouseout", St(n));
    }, lc = tc("path"), dc = Kn("stroke"), bc = F4(function(n, r, t, e) {
        var u, a = e.aV, i = e.y;
        return A2(fc, g([
            cc(i),
            oc(t),
            dc("rgb(169,169,169)"),
            (u = A2(r, ac(i), l(n, {
                G: Wr({
                    Q: e,
                    af: Kr
                })
            })), A2(Ko, "mouseover", St(u))),
            sc(A2(r, Po, l(n, {
                G: Kr
            })))
        ]), A2(re, function(n) {
            return A2(lc, g([
                ic(n)
            ]), b);
        }, a));
    }), vc = function(n) {
        var r = n.Q, t = n.af;
        if (1 === t.$) return ko;
        var e = t.a;
        return A2(mo, g([
            A2(yo, "position", "absolute"),
            A2(yo, "top", No(e.aF.am + e.aD.aq)),
            A2(yo, "left", No(e.aF.al + (e.aD.aC / 2 | 0))),
            A2(yo, "background-color", "white"),
            A2(yo, "padding", "5px"),
            A2(yo, "border-radius", "2px")
        ]), g([
            ho(r.y)
        ]));
    }, hc = F5(function(n, r, t, e, u) {
        var i = n.G;
        return A2(mo, g([
            A2(yo, "width", No(t.aC)),
            A2(yo, "height", No(t.aq)),
            A2(yo, "display", "flex"),
            A2(yo, "justify-content", "center")
        ]), function() {
            if (1 === i.$) return g([
                A2(ec, g([
                    uc(rc(e))
                ]), A2(re, A3(bc, n, r, "rgb(210,180,140)"), u))
            ]);
            var t = i.a;
            return g([
                A2(ec, g([
                    uc(rc(e))
                ]), A2(re, function(e) {
                    return a(t.Q.P, e.P) ? A4(bc, n, r, "rgba(210,180,140,1)", e) : A4(bc, n, r, "rgba(210,180,140,0.3)", e);
                }, u)),
                vc(t)
            ]);
        }());
    }), gc = function(n) {
        var r = n.aV;
        return A2(fc, g([
            cc(n.y),
            oc("rgb(210,180,140)"),
            dc("rgb(169,169,169)")
        ]), A2(re, function(n) {
            return A2(lc, g([
                ic(n)
            ]), b);
        }, r));
    }, pc = F3(function(n, r, t) {
        return A2(mo, g([
            A2(yo, "width", No(n.aC)),
            A2(yo, "height", No(n.aq)),
            A2(yo, "display", "flex"),
            A2(yo, "justify-content", "center")
        ]), g([
            A2(ec, g([
                uc(rc(r))
            ]), A2(re, gc, t))
        ]));
    }), $c = F3(function(n, r, t) {
        return A2(mo, g([
            A2(yo, "display", "flex"),
            A2(yo, "gap", "5px"),
            A2(yo, "line-height", "1")
        ]), g([
            A2(mo, g([
                A2(yo, "width", "85px")
            ]), g([
                n
            ])),
            A2(mo, g([
                A2(yo, "text-align", "right"),
                A2(yo, "width", "90px"),
                A2(yo, "vertical-align", "bottom")
            ]), g([
                ho(Kf(r))
            ])),
            A2(mo, b, t.$ ? b : g([
                ho("(+" + t.a + ")")
            ]))
        ]));
    }), mc = F3(function(n, r, t) {
        var e = t.bi, u = t.a5, a = t.q, i = 800 > n.aC, o = A2(jo, 1e3, n.aC);
        return A2(mo, g([
            A2(yo, "min-height", No(n.aq)),
            A2(yo, "width", No(n.aC)),
            A2(yo, "background-color", $o(1)),
            function() {
                if (1 === u.$) {
                    var n = u.a.A;
                    return Go(A2(r, function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }("guess-input"), 1 === n.$ ? function(n) {
                        var r = n.a5;
                        if (1 === r.$) {
                            var t = r.a;
                            return t.A.$ ? l(n, {
                                a5: ua(l(t, {
                                    s: Hi(t.s),
                                    A: Vi
                                }))
                            }) : n;
                        }
                        return n;
                    }(t) : t));
                }
                return Qo;
            }()
        ]), function() {
            switch(u.$){
                case 0:
                    return g([
                        A2(mo, g([
                            A2(yo, "display", "flex"),
                            A2(yo, "min-height", No(n.aq)),
                            A2(yo, "align-items", "center"),
                            A2(yo, "justify-content", "center")
                        ]), g([
                            A2(mo, g([
                                A2(yo, "display", "flex"),
                                A2(yo, "flex-direction", "column"),
                                A2(yo, "width", No(o)),
                                A2(yo, "background-color", "rgba(255,255,255,0.6)"),
                                A2(yo, "border-radius", i ? "0px" : "10px"),
                                A2(yo, "padding", "20px")
                            ]), g([
                                A2(Ao, b, g([
                                    ho("Fyll kartet: Hvor mange land i " + (w = a.C, (w.$ ? $f(w.a.P) : "verden") + " klarer du?"))
                                ])),
                                A2(mo, g([
                                    A2(yo, "font-size", No(22))
                                ]), g([
                                    A2(Eo, g([
                                        A2(yo, "font-style", "italic")
                                    ]), g([
                                        ho("En morsom og litt annerledes geografi-quiz. Best\xe5r av alle verdens land \u2014 eller begrens omr\xe5det til et kontinent (Europa, Afrika, Asia, Oseania, S\xf8r- eller Nord-Amerika).")
                                    ])),
                                    A2(Eo, b, g([
                                        ho("Skriv inn navnet til alle land du kommer p\xe5. Landene vil plasseres p\xe5 kartet etterhvert som du finner de.")
                                    ])),
                                    A2(Eo, b, g([
                                        ho("Quizen vil best\xe5 av land fra "),
                                        A2(af, g([
                                            A2(yo, "display", "inline-block"),
                                            A2(yo, "font-size", "inherit"),
                                            A2(yo, "font-family", "inherit"),
                                            A2(yo, "border", "none"),
                                            A2(yo, "border-radius", "5px"),
                                            A2(yo, "background-color", "rgba(255,255,204,1)"),
                                            A2(yo, "text-align", "center"),
                                            Xf((k = a.C, k.$ ? k.a.y : "all")),
                                            ef(A2(Ou, r(Po), function(n) {
                                                var r;
                                                return r = A2(ji, pi, A2(Uo, function(n) {
                                                    return function(n) {
                                                        return {
                                                            $: 1,
                                                            a: n
                                                        };
                                                    }(n);
                                                }, _o(A2(wi, function(r) {
                                                    return A2(To, r.y, n);
                                                }, Ro)))), l(t, {
                                                    q: l(a, {
                                                        C: r
                                                    })
                                                });
                                            }))
                                        ]), A2(Dr, A2(uf, g([
                                            Xf("all")
                                        ]), g([
                                            ho("hele verden")
                                        ])), A2(re, function(n) {
                                            return A2(uf, g([
                                                Xf(n.y)
                                            ]), g([
                                                ho($f(n.P))
                                            ]));
                                        }, Ro))),
                                        ho(" \u2014 og du vil f\xe5 "),
                                        A2(Ho, g([
                                            Yf("number"),
                                            A2(yo, "font-size", "inherit"),
                                            A2(yo, "font-family", "inherit"),
                                            A2(yo, "border", "none"),
                                            A2(yo, "background-color", "rgba(255,255,204,1)"),
                                            A2(yo, "border-radius", "5px"),
                                            A2(yo, "width", No(44)),
                                            A2(yo, "text-align", "right"),
                                            Xf(A2(ji, "", A2(Uo, A2(yi, Jf, Yr), a.r))),
                                            ef(A2(Ou, r(Po), function(n) {
                                                var r;
                                                return r = A2(Uo, function(n) {
                                                    return mi(n);
                                                }, A2(Uo, A2(Lo, 1, 30), Bt(n))), l(t, {
                                                    q: l(a, {
                                                        r: r
                                                    })
                                                });
                                            }))
                                        ]), b),
                                        ho(" minutter p\xe5 deg til \xe5 finne s\xe5 mange land som mulig.")
                                    ])),
                                    A2(Eo, b, g([
                                        ho("Hvor mye av kartet klarer du fylle f\xf8r tiden l\xf8per ut?")
                                    ]))
                                ])),
                                A2(mo, g([
                                    A2(yo, "display", "flex"),
                                    A2(yo, "justify-content", "center"),
                                    A2(yo, "padding-top", "20px")
                                ]), g([
                                    A2(Do, g([
                                        A2(yo, "width", i ? "80%" : "40%"),
                                        A2(yo, "font-size", No(22)),
                                        A2(yo, "border-radius", "10px"),
                                        A2(yo, "padding", "10px"),
                                        A2(yo, "background-color", "rgba(255,255,204,1)"),
                                        Go(A2(r, Po, A2(gf, "", t)))
                                    ]), g([
                                        ho("Trykk her for \xe5 starte!")
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]);
                case 1:
                    var f = u.a, s = f.O, d = f.I, v = f.s, h = i ? 40 : 80;
                    return g([
                        f.A.$ ? A2(of, g([
                            A2(yo, "position", "absolute"),
                            A2(yo, "top", "50%"),
                            A2(yo, "transform", "translateY(-50%)"),
                            A2(yo, "width", "100%"),
                            A2(yo, "text-align", "center"),
                            A2(yo, "font-size", "60px"),
                            A2(yo, "color", "white")
                        ]), g([
                            A2(mo, b, g([
                                ho("Begynn taste for \xe5 starte...")
                            ])),
                            A2(mo, g([
                                A2(yo, "font-size", "22px")
                            ]), g([
                                ho(Gf(0) + ": ber\xf8r skjermen for \xe5 f\xe5 opp skjermtastatur")
                            ]))
                        ])) : A2(mo, b, g([
                            A2(mo, g([
                                A2(yo, "position", "absolute"),
                                A2(yo, "top", "50%"),
                                A2(yo, "transform", "translateY(-50%)"),
                                A2(yo, "min-width", No(n.aC))
                            ]), g([
                                A2(mo, g([
                                    Bo("guess-input-background"),
                                    A2(yo, "position", "absolute"),
                                    A2(yo, "left", "50%"),
                                    A2(yo, "transform", "translateX(-50%)"),
                                    A2(yo, "border", "none"),
                                    A2(yo, "min-width", No($t(h * Tt(d) * .6))),
                                    A2(yo, "height", "100%"),
                                    A2(yo, "background-color", "rgb(1,1,1,0.4)")
                                ]), b),
                                A2(Ho, g([
                                    Bo("guess-input"),
                                    A2(yo, "position", "relative"),
                                    Oo("font-mono"),
                                    Fo(!1),
                                    sf(!1),
                                    A2(yo, "border", "none"),
                                    A2(yo, "outline", "none"),
                                    A2(yo, "width", "100%"),
                                    A2(yo, "text-align", "center"),
                                    A2(yo, "font-size", No(h)),
                                    A2(yo, "padding", "10px"),
                                    A2(yo, "background-color", "rgba(0,0,0,0)"),
                                    A2(yo, "color", Tt(d) > 0 ? "rgba(255,255,255, 1)" : "rgba(255,255,255,0)"),
                                    Xf(d),
                                    ef(A2(Ou, r(Po), nf(t)))
                                ]), b)
                            ])),
                            A2(Do, g([
                                A2(yo, "position", "absolute"),
                                A2(yo, "top", "12px"),
                                A2(yo, "right", "12px"),
                                A2(yo, "background-color", "rgba(255,255,204,1)"),
                                A2(yo, "padding", "12px"),
                                A2(yo, "border-radius", "4px"),
                                (p = A2(r, Po, Io(t)), A2(Yo, "click", St(c(p, !0))))
                            ]), g([
                                ho("Avslutt")
                            ]))
                        ])),
                        A2(mo, g([
                            A2(yo, "position", "absolute"),
                            A2(yo, "left", "10px"),
                            A2(yo, "color", "white"),
                            A2(yo, "display", "flex"),
                            A2(yo, "flex-direction", "column")
                        ]), g([
                            A2(mo, g([
                                A2(yo, "font-size", "60px"),
                                A2(yo, "width", "250px")
                            ]), g([
                                nc(v)
                            ])),
                            600 > n.aq ? ko : A2(mo, g([
                                A2(yo, "display", "flex"),
                                A2(yo, "flex-direction", "column"),
                                A2(yo, "gap", "8px")
                            ]), g([
                                A3($c, ho("Antall land:"), nt(s), A2(Uo, function(n) {
                                    return n.y;
                                }, _o(s))),
                                A3($c, ho("Innbyggere:"), A3(Zr, Ur, 0, A2(re, function(n) {
                                    return n.av;
                                }, s)), A2(Uo, Kf, A2(Uo, function(n) {
                                    return n.av;
                                }, _o(s)))),
                                A3($c, A2(of, g([
                                    A2(yo, "position", "relative"),
                                    A2(yo, "top", "-5px")
                                ]), g([
                                    ho("Areal (km"),
                                    A2(pf, b, g([
                                        ho("2")
                                    ])),
                                    ho("): ")
                                ])), A3(Zr, Ur, 0, A2(re, function(n) {
                                    return n.an;
                                }, s)), A2(Uo, Kf, A2(Uo, function(n) {
                                    return n.an;
                                }, _o(s))))
                            ]))
                        ])),
                        A5(hc, f, F2(function(n, e) {
                            return A2(r, n, l(t, {
                                a5: ua(e)
                            }));
                        }), n, (m = a.C, m.$ ? Mo(m.a.P) : A2($a, A2(pa, 0, 0), e)), s)
                    ]);
                default:
                    return s = u.a, g([
                        A2(mo, g([
                            A2(yo, "position", "absolute"),
                            A2(yo, "min-height", No(n.aq))
                        ]), g([
                            A3(pc, n, ($ = a.C, $.$ ? Mo($.a.P) : A2($a, A2(pa, 0, 0), e)), s)
                        ])),
                        A2(mo, g([
                            A2(yo, "display", "flex"),
                            A2(yo, "position", "relative"),
                            A2(yo, "min-height", No(n.aq)),
                            A2(yo, "align-items", "center"),
                            A2(yo, "justify-content", "center")
                        ]), g([
                            A2(mo, g([
                                A2(yo, "background-color", "rgba(255,255,255,0.6)"),
                                A2(yo, "border-radius", "10px"),
                                A2(yo, "padding", "20px"),
                                A2(yo, "display", "flex"),
                                A2(yo, "flex-direction", "column")
                            ]), g([
                                A2(Ao, b, g([
                                    ho("Ferdig!")
                                ])),
                                A2(Eo, g([
                                    A2(yo, "font-size", No(22))
                                ]), g([
                                    ho("Du klarte i l\xf8pet av " + A3(Vo, "minutt", "minutter", Jf(A2(ji, ki.q.r, a.r))) + " \xe5 finne " + Yr(nt(s)) + " land, med en total landmasse p\xe5 " + Kf(A3(Zr, Ur, 0, A2(re, function(n) {
                                        return n.an;
                                    }, s))) + " km"),
                                    A2(pf, b, g([
                                        ho("2")
                                    ])),
                                    ho(".")
                                ])),
                                A2(Eo, g([
                                    A2(yo, "font-size", No(22))
                                ]), g([
                                    ho("Dette ga " + Kf(A3(Zr, Ur, 0, A2(re, function(n) {
                                        return n.av;
                                    }, s))) + " mennesker  fast grunn under f\xf8ttene" + Gf(7))
                                ])),
                                A2(mo, g([
                                    A2(yo, "display", "flex"),
                                    A2(yo, "justify-content", "center"),
                                    A2(yo, "padding-top", "20px")
                                ]), g([
                                    A2(Do, g([
                                        A2(yo, "width", "40%"),
                                        A2(yo, "font-size", No(22)),
                                        A2(yo, "border-radius", "10px"),
                                        A2(yo, "padding", "10px"),
                                        A2(yo, "background-color", "rgba(255,255,204,1)"),
                                        Go(A2(r, Po, Io(t)))
                                    ]), g([
                                        ho("Avslutt")
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]);
            }
            var p, $, m, k, w;
        }());
    }), kc = {
        $: 0
    }, wc = F2(function(n, r) {
        return {
            aD: r,
            aF: n
        };
    }), yc = function(n) {
        return {
            $: 2,
            a: n
        };
    }, xc = {
        al: 0,
        am: 0
    }, Ac = function(n) {
        return {
            P: n.P,
            y: n.R,
            aV: n.aV
        };
    }, zc = function(n) {
        return {
            g: n.g,
            ah: d(n.ad, A2(re, Ac, n.z))
        };
    }, Cc = F2(function(n, r) {
        return A2(Nf, function(r) {
            return a(r, n);
        }, r);
    }), qc = F2(function(n, r) {
        switch(n.P){
            case 0:
                return A2(Cc, r, g([
                    "CT",
                    "ME",
                    "MA",
                    "NH",
                    "RI",
                    "VT",
                    "NJ",
                    "NY",
                    "PA"
                ]));
            case 1:
                return A2(Cc, r, g([
                    "IL",
                    "IN",
                    "MI",
                    "OH",
                    "WI",
                    "IA",
                    "KS",
                    "MN",
                    "MO",
                    "NE",
                    "ND",
                    "SD"
                ]));
            case 2:
                return A2(Cc, r, g([
                    "FL",
                    "GA",
                    "NC",
                    "SC",
                    "VA",
                    "MD",
                    "DE",
                    "WV",
                    "AL",
                    "KY",
                    "MS",
                    "TN",
                    "AR",
                    "LA",
                    "OK",
                    "TX"
                ]));
            default:
                return A2(Cc, r, g([
                    "AZ",
                    "CO",
                    "ID",
                    "MT",
                    "NV",
                    "NM",
                    "UT",
                    "WY",
                    "AK",
                    "CA",
                    "HI",
                    "OR",
                    "WA"
                ]));
        }
    }), jc = F2(function(n, r) {
        return A3(ne, F2(function(r, t) {
            var e = t.a, u = t.b;
            return n(r) ? c(A2(Dr, r, e), u) : c(e, A2(Dr, r, u));
        }), c(b, b), r);
    }), Ec = F3(function(n, r, t) {
        return A2(fc, g([
            oc(n),
            dc(r)
        ]), A2(re, function(n) {
            return A2(lc, g([
                ic(n)
            ]), b);
        }, t));
    }), Nc = F4(function(n, r, t, e) {
        var u = function() {
            if (t.$) {
                var n = t.a;
                return A2(jc, function(r) {
                    return A2(qc, n, r.P);
                }, e);
            }
            return c(e, b);
        }(), a = u.a, i = u.b;
        return A2(mo, g([
            A2(yo, "width", No(n.aC)),
            A2(yo, "height", No(n.aq)),
            A2(yo, "display", "flex"),
            A2(yo, "justify-content", "center")
        ]), g([
            A2(ec, g([
                uc(rc(r))
            ]), d(A2(re, A2(Ec, "#FFCC70", "black"), A2(re, function(n) {
                return n.aV;
            }, a)), A2(re, A2(Ec, "#FFFADD", "black"), A2(re, function(n) {
                return n.aV;
            }, i))))
        ]));
    }), Sc = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Pc = g([
        {
            P: 0,
            y: "North-East"
        },
        {
            P: 1,
            y: "Midwest"
        },
        {
            P: 2,
            y: "South"
        },
        {
            P: 3,
            y: "West"
        }
    ]), Fc = F2(function(n, r) {
        if (n.$) {
            var t = n.a;
            return A2(wi, function(n) {
                return A2(qc, t, n.P);
            }, r);
        }
        return r;
    }), Dc = F2(function(n, r) {
        return nt(A2(Fc, n, r));
    }), Lc = function(n) {
        return {
            P: n.P,
            R: n.y,
            aV: n.aV
        };
    }, Oc = A2(yi, Pf, A2(yi, re(to), Ft)), Tc = function(n) {
        var r = n.P, t = n.R, e = n.aV;
        return {
            n: Oc(t),
            P: r,
            R: t,
            aV: e
        };
    }, Mc = F2(function(n, r) {
        var t = n.q, e = function() {
            var n = t.C;
            if (n.$) {
                var e = n.a;
                return A2(jc, function(n) {
                    return A2(qc, e, n.P);
                }, r);
            }
            return c(r, b);
        }(), u = e.a, a = e.b;
        return c(l(n, {
            a5: function() {
                if (u.b) {
                    var n = u.a, r = u.b;
                    return ro({
                        g: b,
                        W: vf((e = A2(ji, Mi.q.w, t.w), e.$ ? 3e5 : 1 === e.a.$ ? 60 * e.a.a * 1e3 : 1e3 * e.a.a)),
                        m: Tc(Lc(n)),
                        ad: a,
                        z: A2(re, Lc, r),
                        C: Li,
                        k: A2(ji, Mi.q.k, t.k)
                    });
                }
                var e;
                return Di;
            }()
        }), {
            $: 1,
            a: "guess-input"
        });
    }), Qc = function(n) {
        return n.$ ? 0 : n.a.a;
    }, Ic = F3(function(n, r, t) {
        var e, u = t.q, a = t.bs;
        return A2(mo, g([
            A2(yo, "font-size", No(22)),
            A2(yo, "width", No(n)),
            A2(yo, "padding-top", "20px")
        ]), g([
            A2(Eo, b, g([
                ho("Kan du navnet p\xe5 de amerikanske delstatene?")
            ])),
            A2(Eo, b, g([
                ho("En quiz der du finner ut hvilke av de 50 stater i USA du klarer plassere, og som vil hjelpe deg videre ved \xe5 gi hint p\xe5 de du stusser litt p\xe5. Du kan begrense quizen til et gitt antall delstater eller en valgt region for en kortere quiz.")
            ])),
            A2(Eo, b, g([
                ho("Quizen vil best\xe5 av stater fra "),
                A2(af, g([
                    A2(yo, "display", "inline-block"),
                    A2(yo, "font-size", "inherit"),
                    A2(yo, "font-family", "inherit"),
                    A2(yo, "border", "none"),
                    A2(yo, "border-radius", "5px"),
                    A2(yo, "background-color", "rgba(34,102,141,1)"),
                    A2(yo, "color", "white"),
                    A2(yo, "text-align", "center"),
                    Xf((e = u.C, e.$ ? e.a.y : "all")),
                    ef(A2(Ou, r(kc), function(n) {
                        var r;
                        return r = A2(ji, Li, A2(Uo, function(n) {
                            return function(n) {
                                return {
                                    $: 1,
                                    a: n
                                };
                            }(n);
                        }, _o(A2(wi, function(r) {
                            return A2(To, r.y, n);
                        }, Pc)))), l(t, {
                            q: l(u, {
                                C: r,
                                k: Wr(A2(Dc, r, a))
                            })
                        });
                    }))
                ]), A2(Dr, A2(uf, g([
                    Xf("all")
                ]), g([
                    ho("hele USA")
                ])), A2(re, function(n) {
                    return A2(uf, g([
                        Xf(n.y)
                    ]), g([
                        ho(n.y)
                    ]));
                }, Pc))),
                ho(" \u2014 og du vil bli bedt om \xe5 navngi "),
                A2(Ho, g([
                    Yf("number"),
                    A2(yo, "font-size", "inherit"),
                    A2(yo, "font-family", "inherit"),
                    A2(yo, "border", "none"),
                    A2(yo, "background-color", "rgba(34,102,141,1)"),
                    A2(yo, "color", "white"),
                    A2(yo, "border-radius", "5px"),
                    A2(yo, "width", No(44)),
                    A2(yo, "text-align", "right"),
                    Xf(A2(ji, "", A2(Uo, Yr, u.k))),
                    ef(A2(Ou, r(kc), function(n) {
                        var r;
                        return r = A2(Uo, A2(Lo, 1, A2(Dc, u.C, a)), Bt(n)), l(t, {
                            q: l(u, {
                                k: r
                            })
                        });
                    }))
                ]), b),
                ho(" stater i tilfeldig rekkef\xf8lge. Hvis du bruker mer enn "),
                A2(Ho, g([
                    Yf("number"),
                    A2(yo, "font-size", "inherit"),
                    A2(yo, "font-family", "inherit"),
                    A2(yo, "border", "none"),
                    A2(yo, "background-color", "rgba(34,102,141,1)"),
                    A2(yo, "color", "white"),
                    A2(yo, "border-radius", "5px"),
                    A2(yo, "width", No(44)),
                    A2(yo, "text-align", "right"),
                    Xf(A2(ji, "", A2(Uo, A2(yi, Qc, Yr), u.w))),
                    ef(A2(Ou, r(kc), function(n) {
                        var r;
                        return r = A2(Uo, A2(Lo, 2, 30), Bt(n)), l(t, {
                            q: l(u, {
                                w: 1 === r.$ ? Kr : Wr(Ti(Oi(r.a)))
                            })
                        });
                    }))
                ]), b),
                ho(" sekunder p\xe5 \xe5 finne neste korrekte bokstav i navnet, s\xe5 vil denne vises som et hint.")
            ])),
            A2(Eo, b, g([
                ho("Hvor f\xe5 hint trenger du?")
            ])),
            A2(mo, g([
                A2(yo, "display", "flex"),
                A2(yo, "justify-content", "center"),
                A2(yo, "padding-bottom", "60px")
            ]), g([
                A2(Do, g([
                    A2(yo, "font-size", No(22)),
                    A2(yo, "width", "40%"),
                    A2(yo, "border-radius", "10px"),
                    A2(yo, "padding", "10px"),
                    A2(yo, "background-color", "#22668D"),
                    A2(yo, "color", "white"),
                    A2(yo, "border-color", "white"),
                    Go(A2(r, A2(Sc, Mc(t), t.bs), t))
                ]), g([
                    ho("Trykk her for \xe5 starte!")
                ]))
            ]))
        ]));
    }), Vc = F3(function(n, r, t) {
        var e = t.bi, u = t.bs, a = t.q;
        return A2(mo, g([
            A2(yo, "height", No(n.aq)),
            A2(yo, "width", No(n.aC)),
            A2(yo, "display", "flex"),
            A2(yo, "flex-direction", "column"),
            A2(yo, "align-items", "center"),
            A2(yo, "padding-top", "60px"),
            A2(yo, "overflow-x", "hidden")
        ]), g([
            A2(Ao, b, g([
                ho("Stater i USA Quiz")
            ])),
            A4(Nc, A2($e, 800, 500), A2(wc, xc, e), a.C, u),
            A3(Ic, 800, r, t)
        ]));
    }), _c = function(n) {
        return n;
    }, Bc = A2(yi, _c, A2(yi, wi(function(n) {
        switch(n.$){
            case 2:
            case 0:
            case 4:
                return !0;
            default:
                return !1;
        }
    }), nt)), Hc = F2(function(n, r) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    n -= 1, r = r.b;
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), Rc = F2(function(n, r) {
        return 0 > n ? Kr : _o(A2(Hc, n, r));
    }), Uc = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Wc = F3(function(n, r, t) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    var e = r.a;
                    n -= 1, r = r.b, t = A2(Dr, e, t);
                    continue n;
                }
                return t;
            }
            return t;
        }
    }), Kc = F2(function(n, r) {
        return ot(A3(Wc, n, r, b));
    }), Gc = F3(function(n, r, t) {
        if (r > 0) {
            var e = c(r, t);
            n: for(;;){
                r: for(;;){
                    if (!e.b.b) return t;
                    if (!e.b.b.b) {
                        if (1 === e.a) break n;
                        break r;
                    }
                    switch(e.a){
                        case 1:
                            break n;
                        case 2:
                            var u = e.b;
                            return g([
                                u.a,
                                u.b.a
                            ]);
                        case 3:
                            if (e.b.b.b.b) {
                                var a = e.b, i = a.b;
                                return g([
                                    a.a,
                                    i.a,
                                    i.b.a
                                ]);
                            }
                            break r;
                        default:
                            if (e.b.b.b.b && e.b.b.b.b.b) {
                                var o = e.b, f = o.b, s = f.b, l = s.b, d = l.b;
                                return A2(Dr, o.a, A2(Dr, f.a, A2(Dr, s.a, A2(Dr, l.a, n > 1e3 ? A2(Kc, r - 4, d) : A3(Gc, n + 1, r - 4, d)))));
                            }
                            break r;
                    }
                }
                return t;
            }
            return g([
                e.b.a
            ]);
        }
        return b;
    }), Yc = F2(function(n, r) {
        return A3(Gc, 0, n, r);
    }), Jc = F2(function(n, r) {
        return ot(A2(Yc, n, ot(r)));
    }), Xc = F2(function(n, r) {
        return d(n, A2(Jc, nt(r) - nt(n), r));
    }), Zc = F2(function(n, r) {
        for(;;){
            if (a(n, "")) return n;
            if (A2(To, n, A2(_t, Tt(n), r))) return n;
            n = A2(Cf, 1, n);
        }
    }), ns = function(n) {
        return p(n).join("");
    }, rs = A2(yi, _c, A2(yi, re(io(!1)), ns)), ts = F2(function(n, r) {
        var t = A3(rt, F2(function(n) {
            switch(n.$){
                case 0:
                    return Uc(n.a);
                case 2:
                    return function(n) {
                        return {
                            $: 3,
                            a: n
                        };
                    }(n.a);
                case 5:
                case 4:
                    return Uc(n.a.a);
                default:
                    return n;
            }
        }), r, Pf(A2(Zc, n, rs(r))));
        return A2(Xc, t, r);
    }), es = F2(function(n, r) {
        var t = A2(ts, n, r);
        return A2(ut, F2(function(r, t) {
            if (function(n) {
                switch(n.$){
                    case 1:
                    case 3:
                        return !0;
                    default:
                        return !1;
                }
            }(t)) return t;
            if (function(n) {
                switch(n.$){
                    case 2:
                    case 3:
                        return !0;
                    default:
                        return !1;
                }
            }(t)) return t;
            var e = A2(Rc, r, Pf(n));
            if (1 === e.$) return function(n) {
                switch(n.$){
                    case 5:
                    case 2:
                        return !0;
                    default:
                        return !1;
                }
            }(t) ? t : to(A2(io, !1, t));
            var u = e.a;
            return function(n) {
                return {
                    $: 4,
                    a: n
                };
            }(c(A2(io, !1, t), u));
        }), t);
    }), us = F2(function(n, r) {
        return !A2(Nf, A2(Ou, Au, n), r);
    }), as = function(n) {
        return n.a;
    }, is = A2(yi, _c, A2(yi, re(function(n) {
        return 3 === n.$ ? function(n) {
            return {
                $: 1,
                a: n
            };
        }(n.a) : function(n) {
            return {
                $: 0,
                a: n
            };
        }(A2(io, !1, n));
    }), function(n) {
        return A2(us, function(n) {
            return !n.$;
        }, n) ? function(n) {
            return {
                $: 0,
                a: n
            };
        }(ns(A2(re, as, n))) : function(n) {
            return {
                $: 1,
                a: n
            };
        }(n);
    })), os = function(n) {
        var r = n.P, t = n.R, e = n.aV;
        return {
            ab: is(n.n),
            P: r,
            R: t,
            aV: e
        };
    }, fs = F2(function(n, r) {
        return l(r, {
            m: l(r.m, {
                n: n
            })
        });
    }), cs = F2(function(n, r) {
        var t = n.m, e = A2(es, r, t.n);
        if (Bc(e)) return A2(fs, e, n);
        var u = n.z;
        if (u.b) {
            var a = u.a, i = u.b;
            return l(n, {
                g: A2(Dr, os(l(t, {
                    n: e
                })), n.g),
                m: Tc(a),
                z: i
            });
        }
        return l(n, {
            g: A2(Dr, os(l(t, {
                n: e
            })), n.g),
            z: b
        });
    }), ss = A2(yi, _c, A2(yi, Ju(function(n) {
        switch(n.$){
            case 1:
            case 3:
            case 4:
            default:
                return Wr(" ");
            case 2:
                return Wr(n.a);
            case 0:
                return Kr;
        }
    }), ns)), ls = A2(yi, _c, A2(yi, Ju(function(n) {
        switch(n.$){
            case 1:
            case 3:
                return Wr(n.a);
            case 4:
                return Wr(n.a.b);
            default:
                return Kr;
        }
    }), ns)), ds = F2(function(n, r) {
        return $t(r * (n > 600 ? 1 : n > 500 ? 2 / 3 : .5));
    }), bs = A2(yo, "background-color", "rgba(0,0,0,0.0)"), vs = F5(function(n, r, t, e, u) {
        var a = A2(ds, t, 55), i = a / 2 | 0, o = $t(a / 1.65) * (Tt(u) - Tt(e));
        return A2(mo, g([
            A2(yo, "position", "absolute"),
            A2(yo, "width", "100%"),
            A2(yo, "bottom", "0"),
            A2(yo, "overflow", "hidden"),
            A2(yo, "background-color", "rgba(34,34,34,0.5)")
        ]), g([
            A2(Ho, g([
                Bo("guess-hints"),
                Fo(!1),
                sf(!1),
                Xf(u),
                A2(yo, "text-align", "center"),
                A2(yo, "width", "100%"),
                A2(yo, "outline", "0"),
                A2(yo, "border", "0"),
                A2(yo, "margin", "0"),
                A2(yo, "padding", No(i) + " 0px"),
                A2(yo, "color", "#ccc"),
                bs,
                A2(yo, "font-size", No(a)),
                Oo("font-mono")
            ]), b),
            A2(Ho, g([
                Bo(r),
                Fo(!1),
                sf(!1),
                Xf(e),
                A2(yo, "text-align", "center"),
                A2(yo, "position", "absolute"),
                A2(yo, "width", "100%"),
                A2(yo, "top", "0"),
                A2(yo, "left", "0"),
                A2(yo, "outline", "0"),
                A2(yo, "border", "0"),
                A2(yo, "margin", "0"),
                A2(yo, "padding", No(i) + " 0px"),
                A2(yo, "padding-right", No(o)),
                bs,
                A2(yo, "font-size", No(a)),
                A2(yo, "color", "white"),
                Oo("font-mono"),
                ef(n)
            ]), b)
        ]));
    }), hs = F4(function(n, r, t, e) {
        var u, a = e.z, i = e.m, o = e.g, f = e.ad;
        return A2(mo, g([
            A2(yo, "width", No(n.aC)),
            A2(yo, "height", No(n.aq - 100)),
            A2(yo, "display", "flex"),
            A2(yo, "justify-content", "center")
        ]), g([
            A2(ec, g([
                uc(rc(r))
            ]), A2(Dr, A3(Ec, "#8ECDDD", "black", (u = i, u.aV)), d(A2(re, A2(Ec, "#FFFADD", "black"), A2(re, function(n) {
                return n.aV;
            }, a)), d(A2(re, A2(Ec, "#FFCC70", "black"), A2(re, function(n) {
                return n.aV;
            }, o)), A2(re, A2(Ec, "white", "grey"), A2(re, function(n) {
                return n.aV;
            }, f)))))),
            A5(vs, A2(yi, cs(e), t), "guess-input", n.aC, ls(e.m.n), ss(e.m.n))
        ]));
    }), gs = A2(yi, re(function(n) {
        return n.$ ? 1 : 0;
    }), A2(Zr, Ur, 0)), ps = A2(Zr, function(n) {
        return _i(n.a);
    }, ""), $s = Bn("h2"), ms = Bn("h3"), ks = F3(function(n, r, t) {
        var e = t.b;
        return c(n(t.a), r(e));
    }), ws = function(n) {
        return A2(Xi, Ft, n);
    }, ys = function(n) {
        return n.$ ? A2(of, b, A2(re, function(n) {
            var r;
            return n.$ ? (r = n.a, A2(of, g([
                A2(yo, "color", "red")
            ]), g([
                ho(Bi(r))
            ]))) : ho(Bi(r = n.a));
        }, n.a)) : ko;
    }, xs = F3(function(n, r, t) {
        var e = t.ah, u = A2(jc, function(n) {
            return !n.ab.$;
        }, t.g), a = u.a, i = u.b;
        return A2(mo, g([
            A2(yo, "width", No(n)),
            A2(yo, "display", "flex"),
            A2(yo, "justify-content", "center")
        ]), g([
            A2(ec, g([
                uc(rc(r))
            ]), d(A2(re, A2(Ec, "lightblue", "black"), A2(re, function(n) {
                return n.aV;
            }, a)), d(A2(re, A2(Ec, "red", "black"), A2(re, function(n) {
                return n.aV;
            }, i)), A2(re, A2(Ec, "white", "grey"), A2(re, function(n) {
                return n.aV;
            }, e)))))
        ]));
    }), As = F4(function(n, r, t, e) {
        var u, a = e.g, i = A3(ks, ws, Xi(ps), A3(ks, Ju(Ft), Ju(Ft), (u = A2(re, function(n) {
            var r = n.ab;
            return r.$ ? c(Kr, Wr(r.a)) : c(Wr(r.a), Kr);
        }, a), A3(ne, F2(function(n, r) {
            var t = n.b, e = r.b;
            return c(A2(Dr, n.a, r.a), A2(Dr, t, e));
        }), c(b, b), u)))), o = i.a, f = i.b;
        return A2(mo, g([
            A2(yo, "width", No(n.aC)),
            A2(yo, "height", No(n.aq)),
            A2(yo, "display", "flex"),
            A2(yo, "flex-direction", "column"),
            A2(yo, "align-items", "center")
        ]), g([
            A2(mo, g([
                A2(yo, "width", No(800)),
                A2(yo, "font-size", No(22))
            ]), g([
                A2($s, b, g([
                    ho("Ferdig!")
                ])),
                A2(Eo, b, g([
                    ho("Du klarte "),
                    A2(of, g([
                        A2(yo, "color", "blue"),
                        A2(yo, "font-weight", "bold")
                    ]), g([
                        ho(Yr(nt(o)))
                    ])),
                    ho(" stater uten bruk av hint, og trengte hint p\xe5 de "),
                    A2(of, g([
                        A2(yo, "color", "red"),
                        A2(yo, "font-weight", "bold")
                    ]), g([
                        ho(Yr(nt(f)))
                    ])),
                    ho(" resterende. Det ble tilsammen gitt "),
                    A2(of, g([
                        A2(yo, "color", "red")
                    ]), g([
                        ho(Yr(A3(Zr, Ur, 0, A2(re, gs, f))))
                    ])),
                    ho(" hint.")
                ]))
            ])),
            A3(xs, 800, r, e),
            A2(mo, g([
                A2(yo, "display", "flex"),
                A2(yo, "width", No(800)),
                A2(yo, "flex-direction", "column"),
                A2(yo, "align-items", "left")
            ]), g([
                A2(ms, b, g([
                    ho("Hint gitt:")
                ])),
                A2(mo, g([
                    A2(yo, "display", "flex"),
                    A2(yo, "flex-direction", "row"),
                    A2(yo, "gap", "20px"),
                    A2(yo, "flex-wrap", "wrap"),
                    A2(yo, "font-size", "18px")
                ]), A2(re, ys, A2(re, function(n) {
                    return n.ab;
                }, a)))
            ])),
            A2(mo, g([
                A2(yo, "display", "flex"),
                A2(yo, "justify-content", "center"),
                A2(yo, "width", No(800)),
                A2(yo, "padding-top", "60px")
            ]), g([
                A2(Do, g([
                    A2(yo, "font-size", No(22)),
                    A2(yo, "width", "40%"),
                    A2(yo, "border-radius", "10px"),
                    A2(yo, "padding", "10px"),
                    A2(yo, "background-color", "#22668D"),
                    A2(yo, "color", "white"),
                    A2(yo, "border-color", "white"),
                    Go(t)
                ]), g([
                    ho("Avslutt")
                ]))
            ]))
        ]));
    }), zs = F3(function(n, r, t) {
        var e = t.a5, u = t.bi;
        switch(e.$){
            case 0:
                return A3(Vc, n, r, t);
            case 1:
                var i = e.a;
                return A2(mo, b, g([
                    A4(hs, n, A2(wc, xc, u), function(n) {
                        var e;
                        return !(e = n).z.b || a(e.k, nt(e.g)) ? A2(r, kc, l(t, {
                            a5: yc(zc(n))
                        })) : A2(r, kc, l(t, {
                            a5: ro(n)
                        }));
                    }, i),
                    A2(Do, g([
                        A2(yo, "position", "absolute"),
                        A2(yo, "right", "15px"),
                        A2(yo, "top", "15px"),
                        A2(yo, "font-size", No(22)),
                        A2(yo, "border-radius", "10px"),
                        A2(yo, "padding", "10px"),
                        A2(yo, "background-color", "#22668D"),
                        A2(yo, "color", "white"),
                        A2(yo, "border-color", "white"),
                        Go(A2(r, kc, l(t, {
                            a5: Di
                        })))
                    ]), g([
                        ho("Avslutt")
                    ]))
                ]));
            default:
                var o = e.a;
                return A4(As, n, A2(wc, xc, u), A2(r, kc, l(t, {
                    a5: Di
                })), o);
        }
    }), Cs = F5(function(n, r, t, e, u) {
        switch(u.$){
            case 0:
                return ho("Siden finnes ikke");
            case 1:
                var a = u.a;
                switch(a.$){
                    case 0:
                        return A2(mo, g([
                            A2(yo, "height", "100%"),
                            A2(yo, "background-color", go(1))
                        ]), b);
                    case 1:
                        return A2(mo, b, b);
                    default:
                        return "land-i-verden" === a.a ? A2(mo, g([
                            A2(yo, "height", "100%"),
                            A2(yo, "background-color", $o(1))
                        ]), b) : ho("Loading");
                }
            case 2:
                return ko;
            case 3:
                return function(n) {
                    var r = A2(jo, 800, n.aC);
                    return A2(mo, g([
                        A2(yo, "display", "flex"),
                        A2(yo, "flex-direction", "column"),
                        A2(yo, "min-height", "100%"),
                        A2(yo, "align-items", "center")
                    ]), g([
                        A2(mo, g([
                            A2(yo, "width", No(r)),
                            A2(yo, "font-size", "20px")
                        ]), g([
                            A2(Ao, b, g([
                                ho("Quiz p\xe5 Quizleis")
                            ])),
                            A2(Eo, b, g([
                                ho("Quiz per i dag:"),
                                A2(So, b, g([
                                    A2(qo, b, g([
                                        A2(xo, g([
                                            Co("/quiz/land-i-verden")
                                        ]), g([
                                            ho("Land i verden")
                                        ]))
                                    ])),
                                    A2(qo, b, g([
                                        A2(xo, g([
                                            Co("/quiz/stater-i-usa")
                                        ]), g([
                                            ho("Stater i USA")
                                        ]))
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]));
                }(n);
            case 4:
                switch((i = u.a).a5.$){
                    case 0:
                    case 2:
                        return A2(mo, b, g([
                            A3(mc, n, t, i),
                            r
                        ]));
                    default:
                        return A3(mc, n, t, i);
                }
            default:
                var i;
                switch((i = u.a).a5.$){
                    case 0:
                    case 2:
                        return A2(mo, b, g([
                            A3(zs, n, e, i),
                            r
                        ]));
                    default:
                        return A3(zs, n, e, i);
                }
        }
    }), qs = function(n) {
        return "rgba(34,102,141," + po(n) + ")";
    }, js = F2(function(n, r) {
        return A2(mo, g([
            A2(yo, "width", Yr(n) + "em"),
            A2(yo, "height", "1em"),
            A2(yo, "font-size", "inherit"),
            A2(yo, "display", "inline-block")
        ]), g([
            ho(Gf(r))
        ]));
    }), Es = tc("clipPath"), Ns = Kn("clip-path"), Ss = Kn("cx"), Ps = Kn("cy"), Fs = tc("defs"), Ds = tc("ellipse"), Ls = Kn("font-family"), Os = Kn("font-size"), Ts = Kn("font-weight"), Ms = Kn("height"), Qs = F2(function(n, r) {
        return A2(_n, n, function(n) {
            return Gn.test(n) ? "p" : n;
        }(r));
    })("http://www.w3.org/2000/svg"), Is = tc("rect"), Vs = Kn("rx"), _s = Kn("ry"), Bs = Kn("stroke-width"), Hs = vo, Rs = tc("tspan"), Us = Kn("width"), Ws = Kn("x"), Ks = Kn("y"), Gs = A2(ec, g([
        Us("160"),
        Ms("80")
    ]), g([
        A2(Fs, b, g([
            A2(Es, g([
                cc("clipQmark")
            ]), g([
                A2(Is, g([
                    Ws("0"),
                    Ks("10"),
                    Us("100"),
                    Ms("42.5")
                ]), b)
            ]))
        ])),
        A3(Qs, "text", g([
            Ms("10"),
            Ws("0"),
            Ks("60"),
            Ls("chewy"),
            Ns("url(#clipQmark)")
        ]), g([
            A2(Rs, g([
                oc("#f9e3b7"),
                dc("black"),
                Bs("0.05"),
                Os("64"),
                Ts("800")
            ]), g([
                Hs("?")
            ]))
        ])),
        A3(Qs, "text", g([
            Ws("30"),
            Ks("50"),
            Ls("chewy")
        ]), g([
            A2(Rs, g([
                oc("#f9e3b7"),
                dc("black"),
                Bs("0.1"),
                Os("48"),
                Ts("800")
            ]), g([
                Hs("uizleis")
            ]))
        ])),
        A2(Ds, g([
            oc("#f3ab7d"),
            Bs("1.5"),
            dc("black"),
            Ss("16"),
            Ps("59"),
            Vs("4"),
            _s("4")
        ]), b),
        A2(Ds, g([
            oc("#483d8b"),
            dc("black"),
            Ss("59"),
            Ps("16"),
            Vs("5"),
            _s("5")
        ]), b),
        A2(Ds, g([
            oc("#006d6f"),
            dc("black"),
            Ss("127"),
            Ps("16"),
            Vs("5"),
            _s("5")
        ]), b)
    ])), Ys = Kn("dx"), Js = Kn("dy"), Xs = tc("title"), Zs = Kn("transform"), nl = F2(function(n, r) {
        return A2(ec, g([
            Us(Yr(26 * Tt(r))),
            Ms(po(1.15 * n))
        ]), g([
            A2(Xs, b, g([
                Hs(r)
            ])),
            A3(Qs, "text", g([
                Ys("0"),
                Js("0"),
                Zs("translate(6," + po(.8 * n) + ")"),
                Ls("chewy")
            ]), g([
                A2(Rs, g([
                    oc("#f9e3b7"),
                    dc("black"),
                    Bs("0.5"),
                    Os(Yr(n))
                ]), g([
                    Hs(r)
                ]))
            ]))
        ]));
    }), rl = F2(function(n, r) {
        var t = r.ao, e = r.aA, u = 800 > n.aC, a = A2(yo, "border-radius", u ? "0 0 0 0" : "0 0 10px 10px"), i = A2(yo, "border-radius", u ? "0 0 0 0" : "10px 10px 0 0"), o = A2(jo, 800, n.aC), f = u ? o : o / 2 | 0;
        return A2(mo, g([
            A2(yo, "display", "flex"),
            A2(yo, "flex-direction", "column"),
            A2(yo, "min-height", "100%"),
            A2(yo, "align-items", "center"),
            A2(yo, "width", "100%"),
            A2(yo, "justify-content", "center"),
            A2(yo, "background-color", go(1))
        ]), g([
            A2(mo, g([
                A2(yo, "display", "flex"),
                A2(yo, "flex-direction", "column"),
                A2(yo, "width", No(o)),
                A2(yo, "padding-left", "20px"),
                A2(yo, "padding-right", "20px"),
                A2(yo, "color", "#333333"),
                A2(yo, "background-color", "rgba(255,255,255,0.6)"),
                i
            ]), g([
                A2(Ao, g([
                    A2(yo, "font-family", "chewy;serif"),
                    A2(yo, "font-size", "60px"),
                    A2(yo, "display", "flex")
                ]), g([
                    A2(nl, A2(jo, o / 10 | 0, 60), "Velkommen til Quizleis!")
                ])),
                A2(mo, g([
                    A2(yo, "font-size", No(20))
                ]), g([
                    A2(Eo, b, g([
                        A2(js, 2, 7),
                        ho(" Quizleis er en splitter ny nettside. Moro at du tok turen s\xe5 tidlig!")
                    ])),
                    A2(Eo, b, g([
                        A2(js, 2, 6),
                        ho(" Her vil det jevnt og trutt komme "),
                        A2(xo, g([
                            Co("/quiz"),
                            A2(yo, "color", "black")
                        ]), g([
                            ho("sm\xe5 spill")
                        ])),
                        ho(" som quizzer deg innen et bredt utvalg emner.")
                    ])),
                    A2(Eo, b, g([
                        A2(js, 2, 9),
                        ho(" Inntil videre \u2014 hvorfor ikke bryne geografi-kunnskapene dine?")
                    ]))
                ]))
            ])),
            A2(xo, g([
                A2(yo, "display", "flex"),
                A2(yo, "flex-direction", u ? "column" : "row"),
                A2(yo, "width", No(o)),
                A2(yo, "text-decoration", "none"),
                Co("/quiz/land-i-verden")
            ]), g([
                A2(mo, g([
                    A2(yo, "order", u ? "2" : "1"),
                    A2(yo, "background-color", $o(1)),
                    A2(yo, "width", No(f))
                ]), g([
                    A3(pc, A2($e, f, 250), A2($a, xc, t.bi), A2(Yc, e / 3 | 0, t.bs))
                ])),
                A2(mo, g([
                    A2(yo, "order", u ? "1" : "2"),
                    A2(yo, "background-color", "rgba(255,255,204," + po(1) + ")"),
                    A2(yo, "padding", "16px"),
                    A2(yo, "color", "#444"),
                    A2(yo, "width", Yr(f))
                ]), g([
                    A2($s, b, g([
                        A2(nl, 26, "Fyll ut kartet")
                    ])),
                    A2(Eo, g([
                        A2(yo, "font-size", No(20))
                    ]), g([
                        ho("En geografi-quiz der kartet fylles ut etter hvert land du skriver inn. Quiz med land fra hele verden, eller velg en verdensdel.")
                    ])),
                    A2(Eo, g([
                        A2(yo, "font-size", No(20)),
                        A2(yo, "font-style", "italic")
                    ]), g([
                        ho("Klokken tikker! Hvor mye av kartet klarer du fylle?")
                    ]))
                ]))
            ])),
            A2(xo, g([
                A2(yo, "display", "flex"),
                A2(yo, "flex-direction", u ? "column" : "row"),
                A2(yo, "text-decoration", "none"),
                Co("/quiz/stater-i-usa"),
                A2(yo, "width", Yr(o))
            ]), g([
                A2(mo, g([
                    A2(yo, "order", "1"),
                    A2(yo, "background-color", qs(.1)),
                    A2(yo, "color", "white"),
                    A2(yo, "padding", "16px"),
                    A2(yo, "color", "#444"),
                    A2(yo, "width", No(o))
                ]), g([
                    A2($s, b, g([
                        A2(nl, 26, "Stater i USA")
                    ])),
                    A2(Eo, g([
                        A2(yo, "font-size", No(20))
                    ]), g([
                        ho("Kan du navnet p\xe5 alle statene i USA? Hvis ikke vil du bli hjulpet med de du ikke kan.")
                    ])),
                    A2(Eo, g([
                        A2(yo, "font-size", No(20)),
                        A2(yo, "font-style", "italic")
                    ]), g([
                        ho("Hvor f\xe5 hint trenger du?")
                    ]))
                ]))
            ])),
            A2(mo, g([
                A2(yo, "display", "flex"),
                A2(yo, "justify-content", "center"),
                A2(yo, "background-color", "rgba(255,255,255,0.6)"),
                A2(yo, "width", No(o)),
                A2(yo, "padding-top", "5px"),
                a
            ]), g([
                Gs
            ]))
        ]));
    }), tl = function(n) {
        var r = n.ac, t = n.a;
        if (r.$) {
            var e = r.a.aB;
            if (2 === t.$) return A2(rl, e, t.a);
            var u = t;
            return A5(Cs, e, (800 > e.aC ? 1 : 0) ? A2(mo, g([
                A2(yo, "position", "absolute"),
                A2(yo, "left", No(5)),
                A2(yo, "top", No(5)),
                A2(yo, "padding", No(2)),
                A2(yo, "border-radius", No(0))
            ]), g([
                A2(xo, g([
                    Co("/"),
                    Oo("font-mono"),
                    A2(yo, "color", "black"),
                    A2(yo, "font-size", "18px")
                ]), g([
                    ho("Hjem")
                ]))
            ])) : A2(mo, g([
                A2(yo, "position", "absolute"),
                A2(yo, "left", No(20)),
                A2(yo, "top", No(20)),
                A2(yo, "padding", No(20)),
                A2(yo, "border-radius", No(10)),
                A2(yo, "background", "rgb(255,255,255,0.6)")
            ]), g([
                A2(xo, g([
                    Co("/"),
                    Oo("font-mono"),
                    A2(yo, "color", "black"),
                    A2(yo, "font-size", "16px")
                ]), g([
                    ho("Hjem")
                ]))
            ])), lo, bo, u);
        }
        return ho("Loading App");
    }, el = (si = {
        br: F3(function(n, r, t) {
            return A2(iu, r, t);
        }),
        bv: function(n) {
            return {
                $: 7,
                a: n
            };
        },
        bw: function(n) {
            return {
                $: 6,
                a: n
            };
        },
        bA: function(n) {
            var r = n.a, t = function() {
                switch(r.$){
                    case 2:
                        return function(n) {
                            return o(n.aA, 3 * nt(n.ao.bs)) > 0;
                        }(r.a) ? b : g([
                            Mu(bu)
                        ]);
                    case 4:
                        var n = r.a;
                        return 1 === n.a5.$ ? g([
                            Mu(bu),
                            ra(A2(Et, cu, xu)),
                            ea(fu(function(r) {
                                return su(A2(aa, n, r));
                            }))
                        ]) : b;
                    case 5:
                        return 1 === r.a.a5.$ ? g([
                            Mu(bu)
                        ]) : b;
                    default:
                        return g([
                            fa(du),
                            oa(lu)
                        ]);
                }
            }();
            return vu(A2(Dr, A3(na, 1, "resize", A2(hu, "target", A3(Nt, F2(function(n, r) {
                return de(A2($e, n, r));
            }), A2(hu, "innerWidth", ia), A2(hu, "innerHeight", ia)))), t));
        },
        bC: so,
        bE: function(n) {
            return {
                be: g([
                    tl(n)
                ]),
                bB: ou(n.a)
            };
        }
    }, li = si.bv, di = si.bw, bi = function() {
        bi.a(li(Ar()));
    }, wr({
        ax: function(n) {
            return bi.a = n, jr.addEventListener("popstate", bi), 0 > jr.navigator.userAgent.indexOf("Trident") || jr.addEventListener("hashchange", bi), F2(function(r, t) {
                if (!(t.ctrlKey || t.metaKey || t.shiftKey || t.button >= 1 || r.target || r.hasAttribute("download"))) {
                    t.preventDefault();
                    var e = r.href, u = Ar(), a = Gt(e).a;
                    n(di(a && u.a0 === a.a0 && u.aN === a.aN && u.aX.a === a.aX.a ? function(n) {
                        return {
                            $: 0,
                            a: n
                        };
                    }(a) : function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(e)));
                }
            });
        },
        br: function(n) {
            return A3(si.br, n, Ar(), bi);
        },
        bE: si.bE,
        bC: si.bC,
        bA: si.bA
    }));
    ci = {
        Main: {
            init: el(St(0))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? u(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, ci) : n.Elm = ci;
}($a0b4f895e1596b3b$exports);


// HELPERS
JSON.tryParse = function(value) {
    try {
        return JSON.parse(value);
    } catch (error) {
        console.log(`JSON.tryParse error: ${error}`);
        return null;
    }
};
function $35da740d59af89ba$var$storageAvailable(type) {
    let storage;
    try {
        storage = window[type];
        const x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && e.name === "QuotaExceededError" && // acknowledge QuotaExceededError only if there's something already stored
        storage && storage.length !== 0;
    }
}
// END HELPERS
const $35da740d59af89ba$var$APP_NAME = "QUIZLEIS_1";
const $35da740d59af89ba$var$SETTINGS_HINTTIME = `${$35da740d59af89ba$var$APP_NAME}.userSettings.hintTime`;
var $35da740d59af89ba$var$app = (0, $a0b4f895e1596b3b$exports.Elm).Main.init({
    node: document.getElementById("root"),
    flags: null
});
// INTEROP
function $35da740d59af89ba$var$getQuizUri(id) {
    return "/json/" + id + ".json";
}
$35da740d59af89ba$var$app.ports.fetchQuiz.subscribe(function(id) {
    fetch($35da740d59af89ba$var$getQuizUri(id)).then((response)=>{
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json(); // Parse the JSON from the response
    }).then((data)=>{
        $35da740d59af89ba$var$app.ports.receiveQuiz.send(data);
    }).catch((error)=>{
        console.error('Error fetching JSON:', error);
        $35da740d59af89ba$var$app.ports.quizNotFound.send("Quiz not found");
    });
});
$35da740d59af89ba$var$app.ports.updateMetaDescription.subscribe(function(description) {
    const tag = document.querySelector('meta[name="description"]');
    if (tag) tag.setAttribute("content", description);
    else {
        const newMetaTag = document.createElement("meta");
        newMetaTag.setAttribute("name", "description");
        newMetaTag.setAttribute("content", description);
        document.head.appendChild(newMetaTag);
    }
});
$35da740d59af89ba$var$app.ports.getBoundingRect.subscribe(function(id) {
    let bbox = document.getElementById(id).getBoundingClientRect();
    console.log(bbox);
    $35da740d59af89ba$var$app.ports.onReceiveBoundingRect.send(bbox);
}); /*app.ports.persistSettings.subscribe(function (settings) {
    if (!storageAvailable("localStorage"))
        return;

    localStorage.setItem(SETTINGS_HINTTIME, JSON.stringify(settings.hintTime ?? null));
}); */ 


//# sourceMappingURL=index.js.map
